import { Translations } from "i18n/config";

const translations: Translations = {
  accept: "Akzeptieren",
  acceptInterest: "Akzeptieren Sie Interesse",
  account: "Konto",
  accountCreated: "Account erstellt",
  actions: "Aktionen",
  "activity.by": "von {{ displayName }}",
  "activity.CollectionCreated": "{{ title }} erstellt",
  "activity.CollectionDeleted": "{{ title }} gelöscht",
  "activity.CrewMembershipCreated": "{{ title }} erstellt",
  "activity.CrewMembershipDeleted": "{{ title }} gelöscht",
  "activity.CrewMembershipWithdrawn": "{{ title }} zurückziehen",
  "activity.HistoryRecordCreated": "{{ title }} aufgezeichnet",
  "activity.HistoryRecordDeleted": "{{ title }} gelöscht",
  "activity.HistoryRecordRecovered": "{{ title }} wiederhergestellt",
  "activity.ListingCreated": "{{ title }} erstellt",
  "activity.LocationCreated": "{{ title }} erstellt",
  "activity.LocationDeleted": "{{ title }} gelöscht",
  "activity.NegotiationCreated": "{{ title }} erstellt",
  "activity.NegotiationStatusUpdated": "{{ title }} Status aktualisiert",
  "activity.VehicleCollectionsUpdated": "{{ title }} Sammlungen aktualisiert",
  "activity.VehicleConsignmentUpdated": "{{ title }} Zuteilung aktualisiert",
  "activity.VehicleConsignmentUpdated.movedFromTo":
    "{{ title }} Zuteilung von <fromLink>{{ from }}</fromLink> auf <toLink>{{ to }}</toLink> aktualisiert",
  "activity.VehicleConsignmentUpdated.movedTo":
    "{{ title }} Zuteilung auf <toLink>{{ to }}</toLink> aktualisiert",
  "activity.VehicleConsignmentUpdated.removedFrom":
    "{{ title }} von Zuteilung <fromLink>{{ from }}</fromLink> entfernt",
  "activity.VehicleCreated": "{{ title }} erstellt",
  "activity.VehicleDeleted": "{{ title }} gelöscht",
  "activity.VehicleLocationUpdated": "{{ title }} Standort aktualisiert",
  "activity.VehicleLocationUpdated.movedFromTo":
    "{{ title }} Standort von <fromLink>{{ from }}</fromLink> auf <toLink>{{ to }}</toLink> aktualisiert",
  "activity.VehicleLocationUpdated.movedTo":
    "{{ title }} Standort auf <toLink>{{ to }}</toLink> aktualisiert",
  "activity.VehicleLocationUpdated.removedFrom":
    "{{ title }} von Standort <fromLink>{{ from }}</fromLink> entfernt",
  "activity.VehicleRecovered": "{{ title }} wiederhergestellt",
  "activity.VehicleSpecsUpdated": "{{ title }} Spezifikationen aktualisiert",
  "activity.VehicleTechnicalDataUpdated":
    "{{ title }} technische Daten aktualisiert",
  "activity.VehicleVehicleDataUpdated": "{{ title }} Daten aktualisiert",
  add: "Hinzufügen",
  addACollection: "Sammlung hinzufügen",
  addACollector: "Sammler hinzufügen",
  addALocation: "Standort hinzufügen",
  addARecord: "Verlaufseintrag hinzufügen",
  addAService: "Einen Dienst hinzufügen",
  addAVehicle: "Fahrzeug hinzufügen",
  addDataRoom: "Data Room hinzufügen",
  addNewCredential: "Neues Gerät hinzufügen",
  addPhotosAndVideos: "Fügen Sie Fotos und Videos hinzu",
  addPhotosVideosDescription:
    "Für diesen {{entityType}} sind derzeit keine Fotos oder Videos vorhanden.",
  addReminder: "Erinnerung hinzufügen",
  address: "Adresse",
  addressNotFound: "Adresse nicht gefunden",
  addSpecs: "Spezifikationen hinzufügen",
  addSpecsToSection:
    "Für diesen Abschnitt liegen derzeit keine Spezifikationen vor.",
  addTag: "Tag hinzufügen",
  addThisVehicle: "Dieses Fahrzeug hinzufügen",
  addToWishlist: "Zur Wunschliste hinzufügen",
  addVehiclesToCollection: "Fahrzeuge zur Sammlung hinzufügen",
  addVehiclesToLocation: "Fügen Sie Fahrzeuge zum Standort hinzu",
  addVideoOrModelByUrl: "Fügen Sie ein Video oder ein 3D-Modell per URL hinzu",
  addVideoOrModelSupportedProviders:
    "Unterstützte Anbieter: YouTube, Vimeo für Videos und Matterport für 3D-Modelle",
  "admin.customer": "Kunde",
  "alert.curating.button.stop": "Beenden",
  "alert.curating.title": "Kuratiertes Profil „<strong>{{username}}</strong>“",
  amount: "Menge",
  andNMore: "{{entity}} und {{count}} mehr",
  appTheme: "App-Thema",
  "appTheme.acme": "ACME",
  "appTheme.ascari": "Ascari",
  "appTheme.bi": "B.I. COLLECTR",
  "appTheme.curated": "CURATED",
  "appTheme.dark": "Driven - Dunkles",
  "appTheme.driven": "Driven",
  "appTheme.ilr": "ILR",
  "appTheme.kessel": "Kessel",
  "appTheme.light": "Driven - Helles",
  archived: "Archiviert",
  autocompleteHint: "Geben Sie „Neu erstellen“ ein",
  avatar: "Benutzerbild",
  back: "Zurück",
  batch: "Batch",
  becomeMember: "Mitglied werden",
  billing: "Abrechnung",
  "billing.saved": "Gespeicherte Zahlungsarten",
  "billing.selected": "Ausgewählte Zahlungsmethode",
  bio: "Bio",
  cancel: "Abbrechen",
  cancelSubscription: "Abonnement beenden",
  cannotDeleteIfPartOfVerificationProcess:
    "Diese Datei ist Teil eines Verifizierungsprozesses. Sie können es nicht löschen.",
  cannotListVehicleAlreadyListed:
    "Das Fahrzeug ist bereits in den Transaktionen aufgeführt.",
  cannotListVehicleNotSubscribed:
    "Sie müssen ein Abonnement haben, um Fahrzeuge in Transaktionen auflisten zu können.",
  cannotListVehicleOverQuota:
    "Sie haben das Limit an Datenräumen für Ihr aktuelles Abonnement erreicht.",
  cannotListVehicleReadOnly:
    "Sie können dieses Fahrzeug nicht in Transaktionen auflisten, da es schreibgeschützt ist.",
  car: "Auto",
  changeEmail: "Ändern Sie die E-Mail",
  changePassword: "Kennwort ändern",
  changePaymentMethod: "Bezahlungsmethode ändern",
  chassisNumber: "Fahrgestellnummer oder Fahrgestellnummer",
  clearAllFilters: "Alle Filter löschen",
  close: "Schließen",
  collection: "Sammlung",
  "collection.count_one": "{{count}} Sammlung",
  "collection.count_other": "{{count}} Sammlungen",
  "collection.step.pickVehicles.selected": "Du hast ausgewählt",
  collectionNotFound: "Sammlung nicht gefunden",
  collections: "Sammlungen",
  collectorNotFound: "Sammler nicht gefunden",
  concierge: "Concierge",
  condition: "Zustand",
  "condition.average": "Durchschnittlich",
  "condition.clean": "Sauber",
  "condition.damaged": "Beschädigt",
  "condition.description.average":
    "Kann einige mechanische und/oder kosmetische Probleme aufweisen und einen erheblichen Überholungsaufwand erfordern.",
  "condition.description.clean":
    "Einige normale Abnutzungserscheinungen, aber keine grösseren mechanischen oder kosmetischen Probleme; erfordert möglicherweise eine begrenzte Überholung.",
  "condition.description.damaged":
    "Grössere mechanische und/oder kosmetische Schäden, die das Fahrzeug in einen unsicheren Zustand versetzen können.",
  "condition.description.outstanding":
    "Aussergewöhnlicher mechanischer, äußerer und innerer Zustand; erfordert keine Überholung.",
  "condition.description.rough":
    "Mehrere mechanische und/oder kosmetische Probleme, die erhebliche Reparaturen erfordern.",
  "condition.help": "Edmunds Bedingungen helfen",
  "condition.outstanding": "Hervorragend",
  "condition.rough": "Grob",
  confirm: "Bestätigen",
  confirmedPassword: "Bestätigen Sie Ihr Passwort",
  confirmEmailAlert:
    "Bestätigen Sie Ihre E-Mail, überprüfen Sie Ihren Posteingang oder Spam-Ordner auf eine Nachricht von Driven mit einem sicheren Link",
  confirmMfaAuthAppClaim:
    "Bitte geben Sie den 6-stelligen Code <br /> ein, der in Ihrer <strong>Authentifizierungs-App</strong> angezeigt wird",
  confirmMfaClaim: "Bitte geben Sie den 6-stelligen Code {{methodClaim}} ein.",
  confirmMfaEmailClaim:
    "Bitte geben Sie den 6-stelligen Code ein, den Sie an Ihre <strong>E-Mail-Adresse</strong> erhalten haben",
  confirmMfaWebAuthnClaim:
    "Schließen Sie Ihr bevorzugtes <strong>Gerät oder Ihren USB-Stick</strong> an, um den Verifizierungsprozess zu starten",
  "consent.approve": "Genehmigen",
  "consent.clientRequesting":
    "<strong>{{clientName}}</strong> fordert Zugriff auf Ihre Daten an.",
  "consent.dataAccess": "Der Client kann auf folgende Daten zugreifen:",
  "consent.deny": "Ablehnen",
  "consent.invalidRequest":
    "Ungültige Anfrage. Bitte kontaktieren Sie den Support.",
  "consent.warning":
    "Bitte stellen Sie sicher, dass Sie dem Client vertrauen, bevor Sie Zugriff gewähren.",
  consentTerms:
    "Ich habe die <1>Datenschutzerklärung</1> gelesen und akzeptiere die <3>Allgemeinen Geschäftsbedingungen</3>",
  consignment: "Zuteilung",
  contactDriven: "Driven Kontaktieren",
  continue: "Fortsetzen",
  cookiePolicy: "Cookie-Richtlinie",
  copyDataRoomLink: "Link zum Datenraum kopieren",
  copyLink: "Link kopieren",
  copyPrivateLink: "Privaten Link kopieren",
  copyright: "© {{year}} Driven AG. Alle Rechte vorbehalten.",
  copySandboxLink: "Sandkasten-Link kopieren",
  "copySandboxLink.tooltip":
    "Speichern (oder teilen) diesen Link, um auf diese Sandbox bis zum {{expirationDate}} zuzugreifen",
  copyVehicleViewOnlyLink: "Link nur zur Fahrzeugansicht kopieren",
  country: "Land",
  create: "Erstellen",
  created: "Erstellt",
  createNewCollection: "Neue Sammlung erstellen",
  createNewLocation: "Neuen Standort erstellen",
  currency: "Währung",
  currencyRequired: "Währung ist erforderlich",
  currentTierExpirationDate: "Aktuelles Ablaufdatum der Stufe",
  customizeLayout: "Layout anpassen",
  "dashboard.total": "Gesamtwert der Vermögenswerte",
  "dashboard.viewAllActivity": "Alle Aktivitäten anzeigen",
  "dataRoom.group": "Gruppe",
  "dataRoom.guest": "Überprüfen",
  "dataRoom.guest.empty": "Sie sind noch nicht zu einem Datenraum eingeladen",
  "dataRoom.manage": "Verwalten",
  "dataRoom.manage.create": "Datenraum erstellen",
  "dataRoom.manage.empty": "Sie haben noch keine Datenräume erstellt",
  "dataRoom.manage.publicTitle": "Öffentlicher Titel",
  "dataRoom.manage.publicTitle.description":
    "Der öffentliche Titel ist für die von Ihnen eingeladenen Personen sichtbar.",
  "dataRoom.memberships.manage": "Mitgliedschaften",
  "dataRoom.memberships.manage.emptyState.content": "Neue Mitglieder einladen",
  "dataRoom.memberships.manage.invite": "Einladen",
  "dataRoom.permissions.manage": "Erlaubnisse",
  "dataRoom.permissions.noData":
    "Für dieses Fahrzeug gibt es keine Vault-Dateien oder Fahrtenbuchaufzeichnungen.",
  "dataRoom.permissions.section.filesAssignedToLogbookRecord":
    "Dateien, die dem Logbucheintrag zugeordnet sind",
  "dataRoom.permissions.section.filesNotRelatedToLogbookRecord":
    "Dateien ohne Bezug zum Logbucheintrag",
  "dataRoom.permissions.subtitle":
    "Wählen Sie aus, auf welche Logbucheinträge die Gruppe Zugriff hat (Marktwerte, die mit Logbucheinträgen verbunden sind, werden nicht freigegeben)",
  date: "Datum",
  dateDeleted: "Datum gelöscht",
  dateRegistered: "Registrierungsdatum",
  dateUploaded: "Datum des Hochladens",
  decrypt: "Entschlüsseln",
  default: "Standard",
  delete: "Löschen",
  deleteAccount: "Konto löschen",
  deleteFile: "Datei löschen",
  deleteVehicle: "Fahrzeug löschen",
  delisted: "Aus der Liste genommen",
  delistVehicle: "Fahrzeug aus dem Angebot nehmen",
  "density.grid": "Netz",
  "density.list": "Aufführen",
  "density.map": "Karte",
  "density.timeline": "Zeitleiste",
  description: "Beschreibung",
  "description.empty.readonly": "Keine Beschreibung vorhanden",
  "description.generate": "Mit KI generieren",
  "dialog.avatar.content":
    "Sie können die Größe des Bildes ändern und einen bestimmten Bereich auswählen.",
  "dialog.avatar.title": "Avatar",
  "dialog.billingMethod.add.confirmButton": "Zahlungsmethode hinzufügen",
  "dialog.billingMethod.add.content":
    "Geben Sie die Details der Zahlungsmethode ein, die Sie auf Driven verwenden möchten",
  "dialog.billingMethod.add.title": "Neue Zahlungsmethode hinzufügen",
  "dialog.billingMethod.remove.confirmButton": "Zahlungsart löschen",
  "dialog.billingMethod.remove.content":
    "Sie sind dabei, <strong>{{card}}</strong> zu löschen. Dadurch wird diese Zahlungsmethode für zukünftige Einkäufe entfernt.",
  "dialog.billingMethod.remove.title": "Zahlungsart löschen",
  "dialog.billingMethod.removeDefault.content":
    "<strong>{{card}}</strong> ist Ihre bevorzugte Zahlungsmethode. Stellen Sie sicher, dass Sie eine andere Zahlungsmethode hinzufügen oder auswählen, um eine Dienstunterbrechung zu vermeiden.",
  "dialog.collection.delete.title": "Sammlung löschen",
  "dialog.collector.remove.content":
    "Sie sind dabei, <strong>{{username}</strong> aus der <strong>{{organization}</strong> zu entfernen. Sind Sie sich dessen sicher?",
  "dialog.collector.remove.instructions":
    "Bitte geben Sie unten <strong>{{confirmationString}}</strong> zur Bestätigung ein:",
  "dialog.collector.remove.title": "Sammler aus der Organisation entfernen",
  "dialog.collector.remove.warning":
    "Diese Aktion kann nicht rückgängig gemacht werden!",
  "dialog.collector.sendWelcomeEmail": "Willkommens-E-Mail senden",
  "dialog.collector.sendWelcomeEmail.content":
    "Sind Sie sicher, dass Sie die Willkommens-E-Mail an <strong>{{username}}</strong> senden möchten??",
  "dialog.collector.sendWelcomeEmail.userConfirmedWarning":
    "Es wurde bereits eine E-Mail-Einladung verschickt und der Benutzer ist bestätigt.",
  "dialog.concierge.promote.content":
    "Sie sind dabei, <strong>{{fullName}} zu bewerben, sind Sie sicher?",
  "dialog.concierge.promote.title": "Fördern",
  "dialog.concierge.toggleIsActive.content":
    "Sie sind dabei, den <strong>{{fullName}}</strong> zu {{operation}}, sind Sie sich dessen sicher?",
  "dialog.concierge.toggleIsActive.operation.activate": "Aktivieren",
  "dialog.concierge.toggleIsActive.operation.deactivate": "Deaktivieren",
  "dialog.confirm.dataRoom.membership.revoke.content":
    "Sie sind im Begriff, die <strong>{{membershipTitle}}</strong>-Mitgliedschaft aus der Gruppe <strong>{{groupTitle}}</strong> zu widerrufen. Sind Sie sich dessen sicher?",
  "dialog.confirm.dataRoom.membership.revoke.title":
    "Mitgliedschaft widerrufen",
  "dialog.confirm.dataRoom.membership.withdraw.content":
    "Sie sind dabei, Ihre Mitgliedschaft im <strong>{{dataRoomTitle}}</strong> Datenraum zu kündigen. Sind Sie sich dessen sicher?",
  "dialog.confirm.dataRoom.membership.withdraw.title":
    "Mitgliedschaft kündigen",
  "dialog.confirm.default.2fa":
    "Diese Aktion erfordert eine 2FA-Bestätigung, um fortzufahren",
  "dialog.confirm.default.button.cancel": "Abbrechen",
  "dialog.confirm.default.button.confirm": "Bestätigen",
  "dialog.confirm.default.confirmationKeywordInstructions":
    "Bitte geben Sie unten <strong>{{keyword}}</strong> zur Bestätigung ein:",
  "dialog.confirm.default.content": "Möchten Sie fortfahren?",
  "dialog.confirm.default.irreversibleWarning":
    "Diese Aktion kann nicht rückgängig gemacht werden!",
  "dialog.confirm.default.title": "Bestätigen",
  "dialog.confirm.delete.button.confirm": "Ja, löschen",
  "dialog.confirm.delete.content": "Möchten Sie mit der Löschung fortfahren?",
  "dialog.confirm.delete.content_entity":
    "Sie sind dabei, <strong>{{title}}</strong> zu löschen. Sind Sie sicher?",
  "dialog.confirm.delete.title": "Löschen",
  "dialog.confirm.remove.button.confirm": "Ja, entfernen",
  "dialog.confirm.remove.content": "Möchten Sie mit dem Umzug fortfahren?",
  "dialog.confirm.remove.content_entity":
    "Sie sind dabei, <strong>{{title}}</strong> zu entfernen, sind Sie sich dessen sicher?",
  "dialog.confirm.remove.title": "Entfernen",
  "dialog.confirm.transfer.button.confirm": "Ja, übertragen",
  "dialog.confirm.transfer.content":
    "Möchten Sie mit der Übertragung fortfahren?",
  "dialog.confirm.transfer.content_entity":
    "Sie sind im Begriff, <strong>{{title}}</strong> zu übertragen. Sind Sie sicher?",
  "dialog.confirm.transfer.title": "Überweisen",
  "dialog.confirm.unsavedChanges.button.confirm": "Ja, lassen",
  "dialog.confirm.unsavedChanges.content":
    "Änderungen werden verloren gehen, sind Sie sicher, dass Sie gehen wollen?",
  "dialog.confirm.unsavedChanges.title": "Nicht gespeicherte Änderungen",
  "dialog.crew.shareInvitationViaEmail.title":
    "Einladung per E-Mail weitergeben",
  "dialog.dataRoom.delete.content":
    "Sie sind dabei, den Datenraum <strong>{{title}}</strong> zu löschen, sind Sie sich dessen sicher?",
  "dialog.dataRoom.delete.title": "Datenraum löschen",
  "dialog.dataRoom.manage.title": "Datenraum verwalten",
  "dialog.dataRoom.membership.invitation.description":
    "Teilen Sie diesen Link mit {{email}}, um sie in den Datenraum einzuladen",
  "dialog.dataRoom.membership.invitation.title": "{{title}} Mitgliedschaft",
  "dialog.dataRoom.membership.invite.submit": "Einladung versenden",
  "dialog.dataRoom.membership.invite.title": "Benutzer einladen",
  "dialog.email.change.subtitle":
    "Sie erhalten eine Bestätigungs-E-Mail an Ihre neue Adresse. Erst wenn Sie auf den darin enthaltenen Link klicken, wird die Änderung wirksam",
  "dialog.email.change.title": "Ändern Sie die E-Mail",
  "dialog.garage.batch.adding": "Fahrzeuge hinzufügen",
  "dialog.garage.batch.processing": "KI-Magie anwenden",
  "dialog.garage.batch.uploading": "Datei hochladen",
  "dialog.garage.empty.content":
    "Sie haben noch keine Fahrzeuge in Ihrer Garage, die Sie dieser {{collection}} hinzufügen könnten.<br /> Vielleicht ist jetzt ein guter Zeitpunkt, <strong>Ihr erstes Fahrzeug in Ihre Drive Garage hochzuladen!</strong>",
  "dialog.guard.content":
    "Steigen Sie in Ihre eigenen Fahrzeuge ein, verwalten Sie sie wie andere Fahrzeuge und interagieren Sie mit anderen Sammlern und Enthusiasten über ein Konto",
  "dialog.guard.login.title": "Anmeldung",
  "dialog.guard.mfa.title": "Zwei-Faktor-Authentifizierung (2FA)",
  "dialog.guard.resetPassword.title": "Passwort zurücksetzen",
  "dialog.guard.signUp.title": "Melden Sie sich an",
  "dialog.history.delete.bulk.content":
    "Sie sind dabei, alle ausgewählten Datensätze zu löschen, sind Sie sich dessen sicher?",
  "dialog.history.delete.bulk.title": "Ausgewählte Verlaufsdatensätze löschen",
  "dialog.history.delete.content":
    "Sie sind dabei, den Verlaufseintrag vom <strong>{{date}}</strong> zu löschen. Sind Sie sicher?",
  "dialog.history.delete.title": "Verlaufseintrag löschen",
  "dialog.history.review.bulk.content":
    "Sie sind dabei, alle ausgewählten Entwürfe von Verlaufsaufzeichnungen zu speichern, sind Sie sich dessen sicher?",
  "dialog.history.review.bulk.title": "Ausgewählte Datensatzentwürfe speichern",
  "dialog.listing.acceptInterest.button": "Akzeptieren Sie Interesse",
  "dialog.listing.acceptInterest.confirm":
    "Sind Sie sicher, dass Sie dieses Interesse annehmen möchten?",
  "dialog.listing.cancelInterest.buyer.button": "Zinsen abziehen",
  "dialog.listing.cancelInterest.buyer.confirm":
    "Sind Sie sicher, dass Sie Ihr Interesse zurückziehen möchten?",
  "dialog.listing.cancelInterest.seller.button": "Ablehnen",
  "dialog.listing.cancelInterest.seller.confirm":
    "Sind Sie sicher, dass Sie dieses Interesse ablehnen möchten?",
  "dialog.listing.completeNegotiation.confirmButton": "Weitermachen",
  "dialog.listing.completeNegotiation.content":
    "Sie sind dabei, eine digitale Darstellung des Fahrzeugs an den Käufer zu übertragen. Sie behalten das Original in Ihrer Garage.",
  "dialog.listing.completeNegotiation.instructions":
    "Um Ihre Absicht zu bestätigen, müssen Sie unten <strong>‘{{confirmationString}}’</strong> schreiben:",
  "dialog.listing.completeNegotiation.title":
    "Komplettes Verhandlungs- und Transferfahrzeug",
  "dialog.listing.completeNegotiation.warning":
    "Diese Aktion kann nicht rückgängig gemacht werden. Der Käufer erhält eine Kopie des Fahrzeugs, aller Medien, historischen Aufzeichnungen und Dokumente.",
  "dialog.listing.delist.confirmButton": "Ja, delistieren",
  "dialog.listing.delist.content":
    "Sie sind im Begriff, <strong>{{vehicleTitle}}</strong> aus dem Angebot zu entfernen. Sind Sie sicher?",
  "dialog.listing.delist.instructions":
    "Bitte geben Sie unten <strong>{{confirmationString}}</strong> zur Bestätigung ein:",
  "dialog.listing.delist.title": "Fahrzeug aus dem Angebot nehmen",
  "dialog.listing.delist.warning":
    "Diese Aktion kann nicht rückgängig gemacht werden und wirkt sich auf alle laufenden Verhandlungen für dieses Fahrzeug aus!",
  "dialog.listing.details.content":
    "Ihre Privatsphäre ist uns wichtig und wir listen Ihr Fahrzeug anonym auf.",
  "dialog.listing.details.title": "Details auflisten",
  "dialog.listing.selectVehicle.content":
    "Wir werden den Datenraum mit so vielen Informationen wie möglich vorbefüllen.",
  "dialog.listing.selectVehicle.empty": "Kein Fahrzeug passend zu Ihrer Suche",
  "dialog.listing.selectVehicle.title": "Fahrzeug auswählen",
  "dialog.listing.showInterest.confirmButton": "Weitermachen",
  "dialog.listing.showInterest.content":
    "Der Verkäufer muss Ihren Ansatz akzeptieren, bevor Sie mit den Verhandlungen beginnen können.",
  "dialog.listing.showInterest.placeholder":
    "Eine kurze Nachricht, um sich vorzustellen",
  "dialog.listing.showInterest.title": "Zeigen Sie Interesse am Fahrzeug",
  "dialog.listView.save.content":
    "Sie können zu einer Spaltenauswahl zurückkehren, indem Sie eine Ansicht speichern. Von Ihnen gespeicherte Ansichten sind im Bereich „Ansicht auswählen“ verfügbar",
  "dialog.listView.save.title": "Aktuelle Ansicht speichern",
  "dialog.location.delete.title": "Standort löschen",
  "dialog.manageCollectors.title": "Beauftragte verwalten",
  "dialog.media.delete.bulk.content":
    "Sie sind dabei, alle ausgewählten Dokumente zu löschen, sind Sie sich dessen sicher?",
  "dialog.media.delete.bulk.title": "Ausgewählte Dokumente löschen",
  "dialog.media.delete.title": "Dokument löschen",
  "dialog.media.edit.tags.helperText":
    "Wählen Sie eine Kategorie aus, die zum Dokument passt. Sie können auch Ihr eigenes Tag erstellen. Um sie umzubenennen oder zu löschen, gehen Sie zum <1>Tag Manager</1>.",
  "dialog.media.edit.title": "Dokument bearbeiten",
  "dialog.media.edit.warning":
    "Diese Aktion kann nicht rückgängig gemacht werden!",
  "dialog.membership.add.confirmButton": "Hinzufügen",
  "dialog.membership.add.content":
    "Wählen Sie ein neues Besatzungsmitglied aus, indem Sie nach dem Benutzernamen suchen. Das Mitglied muss bereits bei Driven registriert sein.",
  "dialog.membership.add.title": "Neues Besatzungsmitglied hinzufügen",
  "dialog.membership.invite.remove.content":
    "Sie sind dabei, die Einladung zu löschen. Sind Sie sicher?",
  "dialog.membership.invite.remove.title": "Ausstehende Einladung löschen",
  "dialog.membership.remove.confirmButton": "Entfernen",
  "dialog.membership.remove.content":
    "Sie sind dabei, <strong>{{username}}</strong> als Mitglied Ihrer Crew zu entfernen. Sind Sie sicher?",
  "dialog.membership.remove.title": "Mitglied aus der Crew entfernen",
  "dialog.membership.withdraw.confirmButton": "Zurückziehen",
  "dialog.membership.withdraw.content":
    "Sie sind im Begriff, Ihre Mitgliedschaft aus der Crew von <strong>{{username}}</strong> zu entfernen. Sind Sie sicher?",
  "dialog.membership.withdraw.title": "Entzug der Mitgliedschaft aus der Crew",
  "dialog.mfa.disable.content": "Möchten Sie trotzdem fortfahren?",
  "dialog.mfa.disable.subtitle":
    "Sie sind dabei, die Zwei-Faktor-Authentifizierung zu deaktivieren, was die Sicherheit Ihres Kontozugriffs beeinträchtigen kann.",
  "dialog.mfa.disable.title":
    "Deaktivieren Sie die Zwei-Faktor-Authentifizierung",
  "dialog.mfa.enable.subtitle.email":
    "Um diese Methode zu aktivieren, müssen Sie den Bestätigungscode angeben, den wir Ihnen an Ihre E-Mail-Adresse gesendet haben",
  "dialog.mfa.enable.subtitle.otp":
    "Konfigurieren Sie eine Authentifizierungs-App auf Ihrem Smartphone oder einem anderen Gerät, das diesen QR scannt.",
  "dialog.mfa.enable.title":
    "Aktivieren Sie die Multi-Faktor-Authentifizierung",
  "dialog.overQuota.cta": "Upgraden Sie mein Abonnement",
  "dialog.overQuota.description":
    "Unbegrenzte Fahrzeuge<br />Zusammenarbeit<br />...und mehr",
  "dialog.overQuota.subtitle.collector.subscribe":
    "Sie müssen abonniert sein, um diese Aktion durchzuführen",
  "dialog.overQuota.subtitle.collector.upgrade": "Bereit für die Profi-Ebene?",
  "dialog.overQuota.subtitle.curator": "Bitten Sie sie um ein Upgrade",
  "dialog.overQuota.tier.current": "Ihre aktuelle Stufe",
  "dialog.overQuota.title.collector.subscribe": "Abonnieren",
  "dialog.overQuota.title.collector.upgrade":
    "Sie haben das Limit für Ihr aktuelles Abonnement erreicht",
  "dialog.overQuota.title.curator":
    "{{username}} hat das Limit für sein aktuelles Abonnement erreicht",
  "dialog.passphrase.confirm": "Kennwort bestätigen",
  "dialog.passphrase.new": "Neues Kennwort",
  "dialog.passphrase.old": "Altes Kennwort",
  "dialog.passphrase.required.subtitle":
    "Zu Ihrer Sicherheit wird Ihre Passphrase verwendet, um einen Schlüssel zu generieren, der nur vorübergehend gespeichert wird und während Ihrer Sitzung aus dem Speicher gelöscht werden kann. Daher kann es sein, dass Sie aufgefordert werden, Ihre Passphrase erneut einzugeben.",
  "dialog.passphrase.subtitle":
    "Bitte bewahren Sie diese Kennwort an einem sicheren Ort auf. Sie benötigen sie, um auf Ihre verschlüsselten Dateien zuzugreifen. Wenn Sie sie vergessen, kann sie nicht wiederhergestellt werden, und Sie verlieren den Zugriff auf Ihre Daten. Obwohl Sie Ihre Kennwort ändern können, falls sie kompromittiert wird, benötigen Sie dafür das aktuelles Kennwort",
  "dialog.passphrase.title": "Kennwort",
  "dialog.reminder.delete.content":
    "Sie sind dabei, die Erinnerung <strong>{{title}}</strong> für <strong>{{date}}</strong> zu löschen. Sind Sie sicher?",
  "dialog.reminder.delete.title": "Erinnerung löschen",
  "dialog.reminder.manage.title": "Erinnerung verwalten",
  "dialog.remove.confirmButton": "Ja, entfernen",
  "dialog.service.delete.content":
    "Sie sind dabei, den Dienst <strong>{{title}}</strong> zu löschen. Sind Sie sicher?",
  "dialog.service.delete.title": "Dienst löschen",
  "dialog.service.manage.title": "Dienst verwalten",
  "dialog.serviceRequest.accept.confirm":
    "Sind Sie sicher, dass Sie diese Anfrage annehmen möchten?",
  "dialog.serviceRequest.cancel.confirm":
    "Sind Sie sicher, dass Sie diese Anfrage abbrechen möchten?",
  "dialog.serviceRequest.complete.confirm":
    "Sind Sie sicher, dass Sie diesen Antrag ausfüllen möchten?",
  "dialog.serviceRequest.create.title": "Serviceanfrage",
  "dialog.serviceRequest.create.title.withVehicle":
    "{{vehicle}} - Serviceanfrage",
  "dialog.serviceRequest.delete.title": "Serviceanfrage löschen",
  "dialog.serviceRequest.manage.title": "Serviceanfrage verwalten",
  "dialog.subscription.tierSelection.title":
    "Wählen Sie die Stufe, die Ihren Anforderungen entspricht",
  "dialog.tag.create.subtitle":
    "Sie können dieses Tag Ihren Dokumenten zuordnen",
  "dialog.tag.create.title": "Tag erstellen",
  "dialog.tag.delete.content":
    "Sie sind dabei, <strong>{{tagName}}</strong> zu löschen. Dadurch wird das Tag aus allen zugehörigen Dateien entfernt und kann nicht rückgängig gemacht werden. Möchten Sie fortfahren?",
  "dialog.tag.delete.title": "Tag löschen",
  "dialog.tag.delete.warning":
    "Diese Aktion kann nicht rückgängig gemacht werden!",
  "dialog.tag.rename.subtitle":
    "Durch diese Aktion wird das Tag für alle zugehörigen Dateien umbenannt",
  "dialog.tag.rename.title": "Tag umbenennen",
  "dialog.transactions.dataRoom.externalLinks.subtitle":
    "Anschließend können Sie den Zugriff auf diese Gruppe von Links pro Verhandlung zulassen",
  "dialog.transactions.dataRoom.externalLinks.title":
    "Wählen Sie verhandlungsrelevante Links aus",
  "dialog.transactions.dataRoom.gallery.subtitle":
    "Anschließend können Sie den Zugriff auf diese Galerie per Verhandlung zulassen",
  "dialog.transactions.dataRoom.gallery.title":
    "Wählen Sie verhandlungsrelevante Medien aus",
  "dialog.transactions.dataRoom.vault.subtitle":
    "Anschließend können Sie den Zugriff auf diese Dateigruppe per Verhandlung zulassen",
  "dialog.transactions.dataRoom.vault.title":
    "Wählen Sie verhandlungsrelevante Dateien aus",
  "dialog.user.accountDelete.admin.content":
    "Sie sind dabei, das Driven-Konto von <strong>{{user}}</strong> ({{email}}) zu löschen. Sind Sie sicher?",
  "dialog.user.accountDelete.content":
    "Wir bedauern, dass Sie gehen! Sie sind dabei, Ihr Konto zu löschen. Sind Sie sicher?",
  "dialog.user.accountDelete.content.2fa":
    "Diese Aktion erfordert eine 2FA-Bestätigung, um fortzufahren",
  "dialog.user.accountDelete.instructions":
    "Bitte geben Sie unten darunter „<strong>Konto löschen</strong>“ schreiben",
  "dialog.user.accountDelete.title": "Konto löschen",
  "dialog.vehicle.add.managedBy": "Von einem Partner verwaltet?",
  "dialog.vehicle.add.managedByHint":
    "Der Partner kann in Ihrem Namen das Fahrzeug verwalten, einschließlich Vault und Logbuch. Die Abrechnung erfolgt über den Partner.",
  "dialog.vehicle.add.selfManagedHint":
    "Selbstverwaltete Fahrzeuge sind privat, können aber in Zukunft an einen Partner übergeben werden. Die Abrechnung erfolgt im Rahmen Ihres Abonnements.",
  "dialog.vehicle.collection.remove.confirmButton": "Entfernen",
  "dialog.vehicle.collection.remove.content":
    "Sie sind dabei, <strong>{{vehicleTitle}}</strong> aus <strong>{{collectionTitle}}</strong> zu entfernen. Sind Sie sicher?",
  "dialog.vehicle.collection.remove.success":
    "Fahrzeug aus der Sammlung entfernt",
  "dialog.vehicle.collection.remove.title": "Fahrzeug aus der Sammlung nehmen",
  "dialog.vehicle.delete.confirm":
    "Sie sind dabei, <strong>{{title}}</strong> zu löschen. Sind Sie sicher? Während das Fahrzeug wiederhergestellt werden kann, werden alle Datenräume gelöscht und alle Mitgliedschaften entfernt.",
  "dialog.vehicle.delete.managedByPartner":
    "Dieses Fahrzeug wird von einem Partner verwaltet",
  "dialog.vehicle.delete.title": "Fahrzeug löschen",
  "dialog.vehicle.externalLinks.edit.content":
    "Externen Links zu Ihrem Fahrzeug bearbeiten",
  "dialog.vehicle.externalLinks.edit.title": "Externe Links",
  "dialog.vehicle.history.upload.helper":
    "Ziehen Sie alle Dateien oder Medien, die Sie in diese Veranstaltung einbeziehen möchten, per Drag-and-Drop. Sie werden sicher in diesem Fahrzeuges Vault gespeichert. Durch das Entfernen einer Datei wird diese nicht aus dem Vault gelöscht.",
  "dialog.vehicle.historyRecord.draft":
    "Speichern, um den Entwurfsstatus zu entfernen",
  "dialog.vehicle.historyRecord.mileage.error":
    "Erforderlich, wenn der ausgewählte Typ Kilometerzähler ist",
  "dialog.vehicle.historyRecord.price.error":
    "Erforderlich, wenn der ausgewählte Typ Marktwert ist",
  "dialog.vehicle.historyRecord.title": "Logbucheintrag",
  "dialog.vehicle.historyRecord.title.withVehicle":
    "{{vehicle}} - Logbucheintrag",
  "dialog.vehicle.location.managedByPartner":
    "Dieser Fahrzeugstandort wird von einem Partner verwaltet",
  "dialog.vehicle.location.remove.confirmButton": "Entfernen",
  "dialog.vehicle.location.remove.content":
    "Sie sind dabei, <strong>{{vehicleTitle}}</strong> aus <strong>{{locationTitle}}</strong> zu entfernen. Sind Sie sicher?",
  "dialog.vehicle.location.remove.success": "Fahrzeug vom Standort entfernt",
  "dialog.vehicle.location.remove.title": "Fahrzeug vom Standort entfernen",
  "dialog.vehicle.location.update": "Fahrzeugstandort auswählen",
  "dialog.vehicle.organization.assign.success":
    "Fahrzeug der Organisation zugewiesen",
  "dialog.vehicle.organization.assign.title":
    "Fahrzeug der Organisation zuweisen",
  "dialog.vehicle.organization.withdraw.confirmButton": "Zurückziehen",
  "dialog.vehicle.organization.withdraw.content":
    "Sie sind dabei, <strong>{{vehicleTitle}}</strong> aus <strong>{{organization}}</strong> abzuziehen. Sind Sie sicher?",
  "dialog.vehicle.organization.withdraw.success":
    "Fahrzeug von der Organisation zurückgezogen",
  "dialog.vehicle.organization.withdraw.title":
    "Von der Organisation ausscheiden",
  "dialog.vehicle.status.update": "Fahrzeugstatus aktualisieren",
  "dialog.vehicle.tags.edit.title": "Fahrzeugstichworte bearbeiten",
  "dialog.vehicle.transfer.description":
    "Teilen Sie diesen Link mit dem neuen Eigentümer. Wenn dieser die Übertragung akzeptiert, werden Ihnen seine Kontodaten angezeigt, um die Übertragung zu bestätigen. Das Fahrzeug (Vault, Logbuch usw.) wird auf ihr Konto geklont und Sie behalten das Original mit seiner gesamten Historie in Ihrer Garage.",
  "dialog.vehicle.transfer.title": "Transferfahrzeug",
  "dialog.vehicle.unarchive.confirmButton": "Fahrzeug aus dem Archiv entfernen",
  "dialog.vehicle.unarchive.content":
    "Sie sind dabei, <strong>{{vehicleTitle}}</strong> aus dem Archiv wiederherzustellen. Dadurch wird ein Stellplatz in Ihrer Garage beansprucht.",
  "dialog.vehicle.unarchive.title": "Fahrzeug aus Archiv wiederherstellen",
  "dialog.vehicle.vault.assignToHistoryRecord.subtitle":
    "Wählen Sie einen Logbuch-Datensatz aus, dem Sie <strong>{{filename}}</strong> zuordnen möchten.",
  "dialog.vehicle.vault.assignToHistoryRecord.title":
    "Dem Logbucheintrag zuordnen",
  "dialog.vehicle.vault.assignToVehicle.subtitle":
    "Wählen Sie ein Fahrzeug, dem <strong>{{filename}}</strong> zugewiesen werden soll",
  "dialog.vehicle.vault.assignToVehicle.title": "Dem Fahrzeug zuordnen",
  "dialog.vehicle.vault.bin.empty": "Der Korb ist leer.",
  "dialog.vehicle.vault.bin.subtitle":
    "Dokumente werden in den Korb gehalten und können 30 Tage lang wiederhergestellt werden.",
  "dialog.vehicle.vault.bin.title": "Korb",
  "dialog.vehicle.vault.document.decrypt": "Dokument entschlüsseln",
  "dialog.vehicle.vault.document.encrypt": "Dokument verschlüsseln",
  "dialog.wishlist.delete.content":
    "Sie sind dabei, die Wunschliste für <1>{{title}}</1> zu löschen. Sind Sie sicher?",
  "dialog.wishlist.delete.title": "Löschen",
  "dialog.wishlist.details.title": "Fahrzeug in Wunschliste",
  dimensions: "Maße",
  disable: "Deaktivieren",
  discard: "Verwerfen",
  distance: "Distanz",
  distanceUnit: "Entfernungseinheit",
  documents: "Unterlagen",
  download: "Herunterladen",
  draft: "Entwurf",
  drafts: "Entwürfe",
  draftsOnly: "Nur Entwürfe",
  driveTrainLabel: "Antriebsstrang",
  eapBilling: "EAP-Abrechnung",
  eapTier: "EAP-Stufe",
  edit: "Bearbeiten",
  editCollection: "Sammlung bearbeiten",
  editCollector: "Sammler bearbeiten",
  editDescription: "Beschreibung bearbeiten",
  editExternalLinks: "Externe Links bearbeiten",
  editExternalLinksInVehicle: "Externen Links des Fahrzeugs bearbeiten",
  editFile: "Datei bearbeiten",
  editListing: "Datenraum bearbeiten",
  editLocation: "Standort bearbeiten",
  editPhotosAndVideos: "Fotos und Videos bearbeiten",
  editPhotosAndVideosInVehicle: "Fotos und Videos des Fahrzeugs bearbeiten",
  editProfile: "Profil bearbeiten",
  editSpecifications: "Spezifikationen bearbeiten",
  editSpecificationsInVehicle: "Fahrzeugspezifikationen bearbeiten",
  editSpecs: "Spezifikationen bearbeiten",
  editTags: "Stichworte bearbeiten",
  editTechnicalData: "Technische Daten bearbeiten",
  editVaultInVehicle: "Vault des Fahrzeugs bearbeiten",
  editVehicle: "Fahrzeug bearbeiten",
  editVehicleData: "Fahrzeugdaten bearbeiten",
  editWishlist: "Wunschliste bearbeiten",
  email: "Email",
  emailNotSent:
    "E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es später noch einmal.",
  emailSent: "Die Email wurde verschickt",
  emptyActivity: "Für dieses Fahrzeug ist noch keine Aktivität registriert.",
  emptyCollection:
    "Diese Sammlung ist leer. Sie können Ihre gewünschten Fahrzeuge zu dieser Sammlung hinzufügen, indem Sie unten klicken.",
  emptyCollections:
    "Sammlungen sind eine großartige Möglichkeit, Ihre Garage zu organisieren. Sie können jetzt Ihre erste Sammlung erstellen!",
  emptyGarage:
    "Hier finden Sie alle Fahrzeuge, die Sie in Ihre Garage hochladen. Sie können jetzt Ihr erstes Fahrzeug hochladen!",
  emptyGarageLogbook:
    "Hier finden Sie alle historischen Aufzeichnungen aller Fahrzeuge in Ihrer Garage.",
  emptyGarageOnManageVehicles:
    "Sie haben noch kein Fahrzeug in Ihrer Garage. Sie können jetzt Ihr erstes Fahrzeug hochladen!",
  emptyGarageUnsubscribed: "Laden Sie jetzt Ihr erstes Fahrzeug hoch!",
  emptyInvoices:
    "Derzeit sind keine Rechnungen vorhanden. Sobald die erste Rechnung in Rechnung gestellt wurde, wird sie hier angezeigt.",
  emptyLocation:
    "Dieser Standort ist leer. Sie können Ihre gewünschten Fahrzeuge zu diesem Standort hinzufügen, indem Sie unten klicken.",
  emptyLocations:
    "Standorte sind eine großartige Möglichkeit, Ihre Garage zu organisieren. Sie können jetzt Ihren ersten Standort erstellen!",
  emptyPaymentMethods:
    "Sie haben noch keine Zahlungsmethode konfiguriert. Sie können jetzt Ihre erste Zahlungsmethode hinzufügen!",
  enable: "Aktivieren",
  encrypt: "Verschlüsseln",
  engine: "Motor",
  "error.boundary.description":
    "Es tut uns leid, aber es ist etwas schief gelaufen. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie den Support, wenn das Problem weiterhin besteht.",
  "error.boundary.title": "Hoppla! Etwas ist schief gelaufen",
  "error.dataRoom.dataRoomGroupNotFound": "Datenraumgruppe nicht gefunden",
  "error.dataRoom.dataRoomNotFound": "Datenraum nicht gefunden",
  "error.dataRoom.logbookInconsistent": "Datenraum-Logbuch ist inkonsistent",
  "error.dataRoom.membershipNotFound":
    "Datenraum-Mitgliedschaft nicht gefunden",
  "error.dataRoom.membershipSameOwner":
    "Sie können eine Einladung in Ihren eigenen Datenraum nicht bestätigen",
  "error.dataRoom.vaultInconsistent": "Datenraum Vault ist inkonsistent",
  "error.form.maxYear": "Das Jahr muss unter {{year}} liegen.",
  "error.form.minYear": "Das Jahr muss über {{year}} liegen.",
  "error.form.yearToLessThanYearFrom": "Muss größer oder gleich sein",
  "error.historyRecord.notFound": "Verlaufsdatensatz nicht gefunden",
  "error.max.files": "Maximale Anzahl an Dateien überschritten",
  "error.media.fileOversize": "Datei über die maximale Grösse von {{maxSize}}",
  "error.media.invalidFileStorage": "Ungültiger Dateispeicher",
  "error.media.invalidProvider": "Ungültiger Medienanbieter",
  "error.media.mediaCannotBeDeleted":
    "Fehler: Medien können nicht gelöscht werden",
  "error.media.mediaNotFound": "Medien nicht gefunden",
  "error.media.mediaResizeNotAllowed":
    "Die Mediengröße kann nicht geändert werden",
  "error.media.mediaUploadNotAllowed": "Medien können nicht hochgeladen werden",
  "error.media.noTextDetected": "Kein Text erkannt",
  "error.media.systemTagCannotBeDeleted":
    "Systemtag kann nicht gelöscht werden",
  "error.media.systemTagCannotBeRenamed":
    "Systemtag kann nicht umbenannt werden",
  "error.media.tagNameAlreadyExists":
    "Der Tag-Name ist bereits vorhanden. Fehler",
  "error.media.tagNotFound": "Tag nicht gefunden",
  "error.media.vaultNotFound": "Vault nicht gefunden",
  "error.shared.invalidDate": "Ungültiges Datum",
  "error.shared.invalidEmail": "Ungültige E-Mail",
  "error.shared.invalidLimit": "Ungültiger Grenzwert",
  "error.shared.invalidPassword": "Ungültiges Passwort",
  "error.shared.invalidUsername": "Ungültiger Benutzername",
  "error.shared.invalidUuid": "Ungültige UUID",
  "error.shared.invalidVerificationStatus": "Ungültiger Verifizierungsstatus",
  "error.shared.invalidVin": "Ungültige Fahrgestellnummer",
  "error.shared.overQuota": "Aktuelle Quoten erreicht",
  "error.user.cannotDecrypt": "Daten können nicht entschlüsselt werden",
  "error.user.cannotEncrypt": "Daten können nicht verschlüsselt werden",
  "error.user.captchaInvalid": "Captcha kann nicht validiert werden",
  "error.user.collectorCantAddHimselfToCrewError":
    "Der Sammler kann sich nicht selbst als Besatzungsmitglied hinzufügen",
  "error.user.collectorSubscriptionAlreadyActive":
    "Sie sind bereits abonniert. Überprüfen Sie dies in Ihren Abonnementeinstellungen.",
  "error.user.collectorSubscriptionNotPaid":
    "Bezahlung fehlgeschlagen. Verwenden Sie eine andere Zahlungsmethode, um fortzufahren.",
  "error.user.confirmCrewMembershipForbidden":
    "Fehler beim Bestätigen der Crew-Mitgliedschaft",
  "error.user.crewMembershipNotFound":
    "Die Mitgliedschaft wurde nicht gefunden",
  "error.user.emailAlreadyRegistered": "E-Mail bereits registriert",
  "error.user.identificationChangeNotAllowed":
    "Eine Änderung der Identifikationsdaten ist für den aktuellen Status nicht zulässig",
  "error.user.inactiveAccount": "Inaktives Konto",
  "error.user.inappropriateBio": "Bio enthält unangemessene Wörter",
  "error.user.inappropriateUsername":
    "Der Benutzername enthält unangemessene Wörter",
  "error.user.invalidCredentials": "Ungültige Anmeldeinformationen",
  "error.user.invalidEncryptedPassword": "Ungültiges verschlüsseltes Passwort",
  "error.user.invalidProfilePictureOwner": "Ungültiger Profilbildbesitzer",
  "error.user.invalidRejectionReason": "Ungültiger Ablehnungsgrund",
  "error.user.invalidToken": "Ungültiges Token",
  "error.user.invalidTokenScope": "Ungültiger Tokenbereich",
  "error.user.loginFailed": "Fehler bei der Anmeldung",
  "error.user.maxIdentityFilesNumber":
    "Maximale Anzahl an Identitätsdateien erreicht",
  "error.user.multiFactorAuthenticationVerification":
    "Ungültiger 2FA-Bestätigungscode",
  "error.user.profilePictureNotFound": "Profilbild nicht gefunden",
  "error.user.promotionCodeExpired": "Der Aktionscode ist abgelaufen",
  "error.user.promotionCodeInactive": "Aktionscode ist inaktiv",
  "error.user.tokenNotFound": "Token nicht gefunden",
  "error.user.userAlreadyConfirmed": "Benutzer bereits bestätigt",
  "error.user.usernameAlreadyTaken": "Benutzername bereits vergeben",
  "error.user.usernameOrPasswordInvalid": "Benutzername oder Passwort ungültig",
  "error.user.userNotFound": "Benutzer nicht gefunden",
  "error.vehicle.cannotShowInterestForOwnListing":
    "Es kann kein Interesse an einem eigenen Eintrag gezeigt werden",
  "error.vehicle.collectionNotFound": "Sammlung nicht gefunden",
  "error.vehicle.duplicatedListing":
    "Für das Fahrzeug ist eine aktive Auflistung vorhanden",
  "error.vehicle.invalidCurrency": "Ungültige Währung {{currency}}",
  "error.vehicle.invalidDistance": "Ungültige Entfernung",
  "error.vehicle.invalidDistanceUnit": "Ungültige Entfernungseinheit {{unit}}",
  "error.vehicle.invalidMeasure": "Ungültiges Maß für Wert {{value}}",
  "error.vehicle.invalidMonth": "Ungültiger Produktionsmonat",
  "error.vehicle.invalidPrice": "Ungültiger Preis",
  "error.vehicle.invalidPriceRange": "Ungültige Preisspanne",
  "error.vehicle.invalidSpecsString":
    "Ungültige JSON-Zeichenfolge für Spezifikationen",
  "error.vehicle.invalidVehicleForCollection":
    "Ungültiges Fahrzeug zur Abholung",
  "error.vehicle.invalidYear": "Ungültiges Baujahr",
  "error.vehicle.locationNotFound": "Standort nicht gefunden",
  "error.vehicle.mileageNotFound": "Kilometerstand nicht gefunden",
  "error.vehicle.valuationNotFound": "Marktwert nicht gefunden",
  "error.vehicle.vehicleAlreadyClaimed": "Fahrzeug bereits beansprucht",
  "error.vehicle.vehicleClaim": "Beanspruchen des Fahrzeugs fehlgeschlagen",
  "error.vehicle.vehicleNotFound": "Fahrzeug nicht gefunden",
  "error.vehicle.vehicleReadOnly": "Fahrzeug ist schreibgeschützt",
  errorSavingCollection:
    "Beim Speichern der Sammlung ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
  errorSavingCollector:
    "Beim Speichern des Collectors ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
  errorSavingConcierge:
    "Beim Speichern des Concierges ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
  errorSavingLocation:
    "Beim Speichern des Standorts ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
  errorSavingVehicle:
    "Beim Speichern des Fahrzeugs ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
  "exclusivePreview.message":
    "Entdecken Sie Ihr neues Fahrzeug mit Driven Transactions",
  "exclusivePreview.title": "Exklusive Vorschau",
  "exclusivePreviewBlocker.ksp.crew":
    "Bringen Sie Ihre <strong>Crew</strong> mit",
  "exclusivePreviewBlocker.ksp.garageManagement":
    "Professionelles <strong>Garagenmanagement</strong>",
  "exclusivePreviewBlocker.ksp.offMarket":
    "Außerbörsliche <strong>Privatverkäufe</strong>",
  "exclusivePreviewBlocker.seeMore.text":
    "Bei Driven können Sie <strong>Ihre Garage professionell verwalten</strong> und an den ersten <strong>Online-Off-Market-Autotransaktionen</strong> teilnehmen",
  "exclusivePreviewBlocker.seeMore.title":
    "Melden Sie sich an, um mehr zu sehen",
  expiryDate: "Verfallsdatum",
  explore: "Erkunden",
  "explore.empty.content":
    "Keine Ergebnisse gefunden. Versuchen Sie, Ihre <strong>Filter</strong> anzupassen.",
  "explore.empty.title": "keine Ergebnisse gefunden",
  "explore.form.error":
    "Beim Laden der Ergebnisse ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder aktualisieren Sie die Seite",
  exploreVehicles: "Entdecken Sie Fahrzeuge",
  externalId: "Externe ID",
  externalLinks: "Externe Links",
  favorite: "Standardmethode",
  file: "Datei",
  filename: "Dateiname",
  filenameRequired: "Dateiname ist erforderlich",
  "files.count_one": "Datei",
  "files.count_other": "Dateien ({{count}})",
  filesAttached: "Angehängte Dateien",
  "filesAttached.count_one": "Angehängte Datei",
  "filesAttached.count_other": "{{count}} Dateien im Anhang",
  fileUploadHelperText:
    "Ziehen Sie einige Dateien per Drag & Drop hierher oder klicken Sie, um Dateien auszuwählen",
  fileUploadHelperTextSingle:
    "Ziehen Sie eine Datei per Drag & Drop hierher oder klicken Sie, um eine Datei auszuwählen",
  fileVault: "Vault",
  filter: "Filter",
  "filter.listing.visibility": "Zeigen",
  "filter.listing.visibility.active": "Nur aktiv",
  "filter.listing.visibility.delisted": "Nur dekotiert",
  "filter.logbook.record.type": "Typ",
  "filter.logbook.record.type.bought": "Gekauft",
  "filter.logbook.record.type.concoursDElegance": "Concours d'Elegance",
  "filter.logbook.record.type.event": "Ereignis",
  "filter.logbook.record.type.mileage": "Kilometerstand",
  "filter.logbook.record.type.odometer": "Kilometerzähler",
  "filter.logbook.record.type.previousOwner": "Vorbesitzer",
  "filter.logbook.record.type.racetrackEvent": "Rennstrecken-Event",
  "filter.logbook.record.type.restoration": "Wiederherstellung",
  "filter.logbook.record.type.service": "Service",
  "filter.logbook.record.type.sold": "Verkauft",
  "filter.logbook.record.type.trophy": "Trophäe",
  "filter.logbook.record.type.tuning": "Abstimmung",
  "filter.logbook.record.type.unknown": "Unbekannt",
  "filter.logbook.record.type.valuation": "Marktwert",
  "filter.negotiations.role": "Rolle",
  "filter.negotiations.role.buyer": "Käufer",
  "filter.negotiations.role.seller": "Verkäufer",
  "filter.negotiations.status": "Status",
  "filter.negotiations.status.closed": "Geschlossen",
  "filter.negotiations.status.open": "Offen",
  "filter.serviceRequests.status": "Status",
  "filter.serviceRequests.status.canceled": "Abgebrochen",
  "filter.serviceRequests.status.closed": "Geschlossen",
  "filter.serviceRequests.status.completed": "Vollendet",
  "filter.serviceRequests.status.ongoing": "Geht weiter",
  "filter.serviceRequests.status.open": "Offen",
  "filter.serviceRequests.status.requested": "Angefordert",
  "filter.vehicle.visibility": "Sichtweite",
  "filter.vehicle.visibility.all": "Sichtbarkeit: Alle",
  "filter.vehicle.visibility.archived": "Sichtbarkeit: Nur archiviert",
  "filter.vehicle.visibility.transferred": "Sichtbarkeit: Nur übertragen",
  filtered: "Gefiltert",
  finishCuration: "Beenden Sie die Kuration",
  forgotPassword: "Passwort vergessen?",
  freeport: "Freier Port",
  fromYear: "Ab Jahr",
  fullGallery: "Vollständige Galerie",
  gallery: "Galerie",
  garage: "Garage",
  garageError:
    "Beim Laden Ihrer Sammlung ist ein Fehler aufgetreten. Bitte aktualisieren Sie sie",
  generalInfo: "Allgemeine Information",
  goBack: "Zurückgehen",
  goToCollection: "Gehen Sie zur Sammlung",
  goToDetail: "Gehen Sie ins Detail",
  goToHome: "Zur Startseite",
  goToLocation: "Gehen Sie zu Standort",
  goToLogbook: "Gehen Sie zu Logbuch",
  goToLogin: "Gehen Sie zu Anmelden",
  goToSettings: "Gehe zu den Einstellungen",
  goToVault: "Gehen Sie zum Vault",
  goToVehicles: "Gehen Sie zur Fahrzeuge",
  "gpt.reasoning": "KI-Argumentation",
  "gpt.valuation": "KI-Bewertung",
  "gpt.warning":
    "KI kann Fehler machen. Erwägen Sie, wichtige Informationen zu überprüfen.",
  "grid.bin": "Korb",
  "grid.bulkEdit": "Bulk",
  "grid.export.csv": "CSV",
  "grid.exportCurrentView": "Aktuelle Ansicht exportieren",
  "grid.hideAll": "Versteck alles",
  "grid.save": "Speichern",
  "grid.saveAs": "Speichern als",
  "grid.selectColumns": "Spalten",
  "grid.selectView": "Ansicht auswählen",
  "grid.showAll": "Zeige alles",
  help: "Hilfe",
  helpCenter: "Hilfe-Center",
  highlight: "Markieren",
  highlights: "Markierungen",
  highlightsOnly: "Nur Highlights",
  history: "Geschichte",
  historyRecord: "Logbucheintrag",
  "historyRecord.add": "Verlaufseintrag hinzufügen",
  "historyRecord.add.error.content":
    "Beim Hinzufügen Ihres Verlaufseintrags ist ein Problem aufgetreten.",
  "historyRecord.add.marketValue": "Marktwertaufzeichnung hinzufügen",
  "historyRecord.add.odometerReading":
    "Aufzeichnung des Kilometerstandes hinzufügen",
  "historyRecord.attachments.help":
    "Auf Anbaugeräte kann auch vom den Vault des Fahrzeugs aus zugegriffen werden.",
  "historyRecord.deleteRecords": "Datensätze löschen",
  "historyRecord.edit": "Verlaufsdatensatz bearbeiten",
  "historyRecord.empty":
    "Es liegen noch keine historischen Aufzeichnungen vor. Fügen Sie das erste hinzu und beginnen Sie mit der Erstellung der Geschichte Ihrer Fahrzeuge!",
  "historyRecord.goTo": "Gehen Sie zum Verlaufsdatensatz",
  "historyRecord.recordedOn": "Aufgezeichnet am {{date}}",
  "historyRecord.reviewDraft": "Entwurf überprüfen",
  "historyRecord.saveDrafts": "Entwürfe speichern",
  "historyRecord.step.details.description":
    "Sie können Ihren eigenen Verlaufsaufzeichnungstyp erstellen",
  "historyRecord.step.details.title": "Logbucheintrag",
  "historyRecord.type.bought": "Gekauft",
  "historyRecord.type.concoursDElegance": "Concours d'Elegance",
  "historyRecord.type.custom": "Brauch",
  "historyRecord.type.event": "Ereignis",
  "historyRecord.type.odometer": "Kilometerzähler",
  "historyRecord.type.previousOwner": "Vorbesitzer",
  "historyRecord.type.racetrackEvent": "Rennstreckenveranstaltung",
  "historyRecord.type.restoration": "Wiederherstellung",
  "historyRecord.type.service": "Service",
  "historyRecord.type.sold": "Verkauft",
  "historyRecord.type.trophy": "Trophäe",
  "historyRecord.type.tuning": "Abstimmung",
  "historyRecord.type.unknown": "Unbekannt",
  "historyRecord.type.valuation": "Marktwert",
  id: "ID",
  idle: "Leerlauf",
  import: "Importieren",
  inactive: "inaktiv",
  insuredValue: "Versicherter Wert",
  invoiceNumber: "Rechnungsnummer",
  invoicesError:
    "Die Rechnungsliste ist derzeit nicht verfügbar. Bitte aktualisieren Sie die Seite oder versuchen Sie es später noch einmal. Ihre Daten sind sicher.",
  issuedDate: "Ausstellungsdatum",
  joinTheCommunity: "Treten Sie der Community bei",
  km: "Kilometer",
  language: "Sprache",
  "language.de": "Deutsch",
  "language.en": "English",
  languageRequired: "Sprache ist erforderlich",
  latestAccesses: "Neueste Zugriffe",
  "layouts.block.empty.edit":
    "Wählen Sie die Blöcke oben aus, die Sie in Ihrem Dashboard sehen möchten",
  "layouts.block.empty.view":
    "Gehen Sie in den Bearbeitungsmodus, um die Blöcke auszuwählen, die Sie in Ihrem Dashboard sehen möchten",
  "layouts.dashboard.block.ai-valuation": "KI-Bewertung",
  "layouts.dashboard.block.financial-summary": "Finanzielle Zusammenfassung",
  "layouts.dashboard.block.financial-summary-total-current-price":
    "Gesamtwert der Aktiva",
  "layouts.dashboard.block.financial-summary-total-purchase-price":
    "Gesamtkäufe",
  "layouts.dashboard.block.financial-summary-total-realized-gain":
    "Realisierter Gewinn",
  "layouts.dashboard.block.financial-summary-total-sales-price": "Gesamtumsatz",
  "layouts.dashboard.block.financial-summary-total-unrealized-gain":
    "Unrealisierter Gewinn",
  "layouts.dashboard.block.latest-activity": "Neueste Aktivität",
  "layouts.dashboard.block.latest-memory": "Erinnerungen",
  "layouts.dashboard.block.performance-chart": "Leistungsdiagramm",
  "layouts.dashboard.block.your-garage": "Ihre Garage",
  "layouts.vehicleDetail.block.activity": "Aktivität",
  "layouts.vehicleDetail.block.ai-valuation": "KI-Bewertung",
  "layouts.vehicleDetail.block.collections": "Sammlungen",
  "layouts.vehicleDetail.block.description": "Beschreibung",
  "layouts.vehicleDetail.block.external-links": "Externe Links",
  "layouts.vehicleDetail.block.gallery": "Galerie",
  "layouts.vehicleDetail.block.insurance-value": "Versicherungswert",
  "layouts.vehicleDetail.block.location": "Standort",
  "layouts.vehicleDetail.block.market-valuation": "Marktwert",
  "layouts.vehicleDetail.block.mileage": "Kilometerstand",
  "layouts.vehicleDetail.block.performance": "Leistung",
  "layouts.vehicleDetail.block.purchase-price": "Kaufpreis",
  "layouts.vehicleDetail.block.reminders": "Erinnerungen",
  "layouts.vehicleDetail.block.sale-price": "Verkaufspreis",
  "layouts.vehicleDetail.block.specifications": "Spezifikationen",
  "layouts.vehicleDetail.block.taxable-value": "Steuerpflichtiger Wert",
  "layouts.vehicleDetail.block.technical-data": "Technische Daten",
  "layouts.vehicleDetail.block.valuation": "Bewertung",
  "layouts.vehicleDetail.block.vehicle-data": "Fahrzeugdaten",
  licensePlate: "Nummernschild",
  linkCopied: "Link kopiert",
  listed: "Gelistet",
  "listing.status.active": "Aktiv",
  "listing.status.delisted": "Aus der Liste genommen",
  listVehicle: "Fahrzeug bei Transaktionen auflisten",
  loading: "Wird geladen…",
  loadRest: "Ruhe laden",
  location: "Standort",
  "location.count_one": "{{count}} Standort",
  "location.count_other": "{{count}} Standorte",
  "location.managedByPartner":
    "Dieser Standort wird verwaltet von <strong>{{title}}</strong>",
  "location.step.pickVehicles.selected": "Du hast ausgewählt",
  locationNotFound: "Standort nicht gefunden",
  locations: "Standorte",
  locationType: "Standorttyp",
  logBook: "Logbuch",
  "logBook.makeModel": "{{make}} {{model}}s Logbuch",
  logbookInvitation:
    "Das Logbuch hilft Ihnen, eine detaillierte Historie Ihres Fahrzeugs zu führen. Sie können sofort loslegen, indem Sie einen der folgenden Einträge hinzufügen. <1>Alle von Ihnen hochgeladenen Dokumente werden sicher in Ihrem Vault gespeichert.</1>",
  login: "Anmeldung",
  loginClaim: "Noch kein Mitglied?",
  loginError:
    "Ungültige Anmeldeinformationen. Setzen Sie Ihr Passwort zurück, wenn Sie bereits registriert sind, oder vermeiden Sie Schimpfwörter",
  loginHere: "Hier anmelden",
  logout: "Ausloggen",
  "maintenance.description":
    "Da Driven aufgrund von Wartungsarbeiten außer Betrieb ist, können Sie in Kürze wieder auf die Plattform zugreifen. <strong>Folgen Sie uns auf unseren sozialen Medien für Updates.</strong>",
  "maintenance.subtitle": "Wir sind in Kürze wieder unterwegs!",
  "maintenance.title": "Uh-oh... Motor prüfen!",
  make: "Marke",
  makes: "Marken",
  manageCollections: "Sammlungen verwalten",
  manageLocations: "Standorte verwalten",
  manageVehicle: "Fahrzeug verwalten",
  maxPrice: "Maximaler Preis",
  measurementDate: "Messdatum",
  member: "Mitglied",
  message: "Nachricht",
  "messageBoard.role.admin": "Admin",
  "messageBoard.role.collector": "Sammler",
  "messageBoard.role.concierge": "Concierge",
  "messageBoard.role.curator": "Curator",
  "messageBoard.role.unknown": "Unbekannt",
  "messageBoard.role.you": "Sie",
  "messageBoard.send": "Schicken",
  "messageBoard.system.dataRoom.layout_membership_confirmed_v1":
    "{{fullName}} hat eine Einladung in den Datenraum angenommen",
  "messageBoard.system.dataRoom.layout_membership_confirmed_v1.preview":
    "Einladung zum Datenraum angenommen",
  "messaging.admin.user.deleted": "Benutzer gelöscht",
  "messaging.collection.added": "Sammlung hinzugefügt",
  "messaging.collection.deleted": "Sammlung gelöscht",
  "messaging.collection.details.updated": "Sammlungsdetails aktualisiert",
  "messaging.collection.vehicles.updated":
    "Fahrzeuge in der Sammlung aktualisiert",
  "messaging.collector.added": "Sammler hinzugefügt",
  "messaging.collector.details.updated": "Sammlerdetails aktualisiert",
  "messaging.concierge.added": "Concierge erstellt",
  "messaging.concierge.isActiveUpdated.activated": "Aktiviert",
  "messaging.concierge.isActiveUpdated.deactivated": "Deaktiviert",
  "messaging.concierge.promoted": "{{fullName}} befördert",
  "messaging.concierge.promoted.error": "Fehler beim Bewerben von {{fullName}}",
  "messaging.crew.invitation.sent": "Einladung verschickt",
  "messaging.curation.add": "{{member}} wurde zu Ihrer Crew hinzugefügt",
  "messaging.curation.end": "Die Kurationssitzung ist beendet",
  "messaging.curation.remove":
    "{{member}} ist nicht mehr Teil der Crew von {{manager}}",
  "messaging.curation.start":
    "Kurationssitzung für die Garage von {{username}} gestartet",
  "messaging.dataRoom.added": "Data Room hinzugefügt",
  "messaging.dataRoom.deleted": "Data Room gelöscht",
  "messaging.dataRoom.group.updated": "Datenraumgruppe aktualisiert",
  "messaging.dataRoom.membership.invitationCreated":
    "Einladung zur Mitgliedschaft erstellt",
  "messaging.dataRoom.membership.revoked": "Entzug der Mitgliedschaft",
  "messaging.dataRoom.membership.revoked.failed":
    "Die Mitgliedschaft wurde nicht widerrufen",
  "messaging.dataRoom.membership.withdrawn": "Entzug der Mitgliedschaft",
  "messaging.dataRoom.membership.withdrawn.failed":
    "Failed to withdraw membership",
  "messaging.dataRoom.permissions.updated":
    "Berechtigungen für den Datenraum aktualisiert",
  "messaging.dataRoom.updated": "Data Room aktualisiert",
  "messaging.dealer.added": "Händler hinzugefügt",
  "messaging.error.tryAgain":
    "Etwas ist schief gelaufen. Bitte versuche es erneut.",
  "messaging.garage.vehicles.added": "Fahrzeuge zur Garage hinzugefügt",
  "messaging.historyRecord.added": "Verlaufseintrag hinzugefügt",
  "messaging.historyRecord.details.updated":
    "Details des Verlaufsdatensatzes gespeichert",
  "messaging.listing.created": "Datenraum erstellt",
  "messaging.listing.delisted": "Datenraum aus der Liste entfernt",
  "messaging.listing.interest.accepted": "Interesse angenommen",
  "messaging.listing.interest.rejected": "Zinsen abgelehnt",
  "messaging.listing.interest.withdrawn": "Zinsen zurückgezogen",
  "messaging.listing.updated": "Datenraum aktualisiert",
  "messaging.location.added": "Standort hinzugefügt",
  "messaging.location.deleted": "Standort gelöscht",
  "messaging.location.details.updated": "Standortdetails aktualisiert",
  "messaging.location.vehicles.updated": "Fahrzeuge vor Ort aktualisiert",
  "messaging.mfa.confirmed": "2FA bestätigt",
  "messaging.mfa.disabled": "2FA erfolgreich deaktiviert",
  "messaging.mfa.enabled": "2FA erfolgreich aktiviert",
  "messaging.reminder.created": "Erinnerung erstellt",
  "messaging.reminder.deleted": "Erinnerung gelöscht",
  "messaging.reminder.updated": "Erinnerung aktualisiert",
  "messaging.service.created": "Dienst erstellt",
  "messaging.service.deleted": "Dienst gelöscht",
  "messaging.service.updated": "Dienst aktualisiert",
  "messaging.serviceRequest.accepted": "Serviceanfrage angenommen",
  "messaging.serviceRequest.canceled": "Serviceanfrage abgebrochen",
  "messaging.serviceRequest.created": "Dienst angefordert",
  "messaging.serviceRequest.deleted": "Serviceanfrage gelöscht",
  "messaging.serviceRequest.updated": "Serviceanfrage aktualisiert",
  "messaging.settings.creditCard.deleted": "Kreditkarte erfolgreich gelöscht",
  "messaging.settings.creditCard.setDefault":
    "Kreditkarte erfolgreich als Standard festgelegt",
  "messaging.subscription.invoice.downloading":
    "Rechnungs-Download wird vorbereitet",
  "messaging.tag.created": "Tag erstellt",
  "messaging.tag.deleted": "Tag gelöscht",
  "messaging.tag.renamed": "Tag umbenannt",
  "messaging.user.added": "Benutzer erstellt",
  "messaging.user.avatar.updated": "Profilbild aktualisiert",
  "messaging.user.crewMembership.inviteCreated": "Die Einladung wurde erstellt",
  "messaging.user.crewMembershipCreated.verified":
    "Besatzungsmitgliedschaft akzeptiert",
  "messaging.user.data.updated": "Benutzerdaten aktualisiert",
  "messaging.user.email.changing": "E-Mail an neue E-Mail-Adresse gesendet",
  "messaging.user.email.verified": "Email überprüft",
  "messaging.user.listView.saved": "Listenansicht gespeichert",
  "messaging.user.passphrase.updated": "Kennwort aktualisiert",
  "messaging.user.passphrase.used": "Data Encryption Key verfügbar",
  "messaging.user.password.updated": "Passwort aktualisiert",
  "messaging.user.paywall.changed": "Paywall-Einstellungen aktualisiert",
  "messaging.user.paywall.error":
    "Fehler beim Aktualisieren der Paywall-Einstellungen",
  "messaging.user.verification.submitted": "Verifizierungsanfrage eingereicht",
  "messaging.user.welcome": "Willkommen",
  "messaging.vehicle.added": "Fahrzeug hinzugefügt",
  "messaging.vehicle.collections.updated": "Fahrzeugsammlungen aktualisiert",
  "messaging.vehicle.consignment.updated": "Fahrzeugversand aktualisiert",
  "messaging.vehicle.deleted": "Fahrzeug gelöscht",
  "messaging.vehicle.details.updated": "Fahrzeugdetails aktualisiert",
  "messaging.vehicle.externalLinks.updated":
    "Externe Fahrzeuglinks aktualisiert",
  "messaging.vehicle.history.deleted": "Fahrzeugverlaufsdatensatz entfernt",
  "messaging.vehicle.history.deleted.bulk":
    "Ausgewählte Historieneinträge entfernt",
  "messaging.vehicle.history.deleted.bulk.error":
    "Es konnten nicht alle ausgewählten Verlaufsdatensätze entfernt werden",
  "messaging.vehicle.history.draft.saved.bulk":
    "Ausgewählte Datensatzentwürfe gespeichert",
  "messaging.vehicle.history.draft.saved.bulk.error":
    "Alle ausgewählten Entwürfe von Verlaufsdatensätzen konnten nicht gespeichert werden",
  "messaging.vehicle.history.recovered":
    "Fahrzeugverlaufsdatensatz wiederhergestellt",
  "messaging.vehicle.location.updated": "Fahrzeugstandort aktualisiert",
  "messaging.vehicle.recovered": "Fahrzeug wiederhergestellt",
  "messaging.vehicle.specs.updated": "Fahrzeugspezifikationen aktualisiert",
  "messaging.vehicle.status.updated": "Fahrzeugstatus aktualisiert",
  "messaging.vehicle.technicalData.updated":
    "Technische Daten des Fahrzeugs aktualisiert",
  "messaging.vehicle.transfer.claimed": "Fahrzeugübertragung beansprucht",
  "messaging.vehicle.vault.document.decrypted": "Dokument entschlüsselt",
  "messaging.vehicle.vault.document.deleted": "Dokument entfernt",
  "messaging.vehicle.vault.document.deleted.bulk": "Dokumente entfernt",
  "messaging.vehicle.vault.document.deleted.bulk.error":
    "Es konnten nicht alle ausgewählten Verlaufsdatensätze entfernt werden",
  "messaging.vehicle.vault.document.encrypted": "Dokument verschlüsselt",
  "messaging.vehicle.vault.document.recovered": "Dokument wiederhergestellt",
  "messaging.vehicle.vault.document.updated": "Dokument aktualisiert",
  "messaging.vehicle.vault.uploaded": "Dokument hochgeladen",
  "messaging.vehicle.verification.submitted":
    "Verifizierungsanfrage eingereicht",
  "messaging.welcomeEmail.sent": "Willkommens-E-Mail gesendet",
  "messaging.wishlist.created": "Zur Wunschliste hinzugefügt",
  "messaging.wishlist.deleted": "Von der Wunschliste entfernt",
  "messaging.wishlist.deleteOriginal":
    "Ursprüngliches Element auf der Wunschliste löschen",
  "messaging.wishlist.specs.updated":
    "Wunschliste Spezifikationen aktualisiert",
  "messaging.wishlist.updated": "Wunschliste aktualisiert",
  mfaCantAccessAuthApp:
    "Sie können nicht auf Ihre Authentifizierungs-App zugreifen?",
  mfaCantAccessEmail: "Sie können nicht auf Ihre E-Mails zugreifen?",
  mfaCantAccessWebAuthn: "Haben Sie Ihr Gerät nicht dabei?",
  mfaCodeError: "Der Code ist falsch, bitte versuchen Sie es erneut",
  mfaCodeRequired: "Es ist ein 6-stelliger Code erforderlich",
  mfaDeviceAuthenticationError:
    "Beim Verifizieren Ihres Geräts ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
  mfaMethodError:
    "Bei der Verwaltung der 2FA-Methode ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut",
  mfaMethodRequired: "Methode ist gefragt",
  mfaTokenRequired: "MFA-Token ist erforderlich",
  mfaUseAuthApp: "Verwenden Sie die Authentifizierungs-App",
  mfaUseEmail: "Code per E-Mail senden",
  mfaUseWebAuthn: "Verwenden Sie ein physisches Gerät",
  mi: "Meilen",
  minPrice: "Mindestpreis",
  model: "Modell",
  models: "Modelle",
  month: "Monat",
  moreActions: "Mehr Aktionen",
  motorcycle: "Motorrad",
  myListings: "Meine Datenräume",
  name: "Vorname",
  nameRequired: "Name ist erforderlich",
  needHelp: "Brauchen Sie Hilfe?",
  "negotiation.backToNegotiation": "Zurück zu Diskussionen",
  "negotiation.closedDiscussions": "Geschlossene Diskussionen",
  "negotiation.messages.disabled.buyerCannotChat":
    "Der Käufer darf Ihnen keine weiteren Nachrichten senden, es sei denn, die Diskussion läuft noch",
  "negotiation.messages.disabled.buyerInterestStatus":
    "Sie können keine weiteren Nachrichten senden, bevor der Verkäufer Ihr Interesse akzeptiert.",
  "negotiation.messages.disabled.canceledStatus":
    "Die Diskussion wurde abgebrochen",
  "negotiation.messages.disabled.completedStatus":
    "Die Diskussion ist abgeschlossen",
  "negotiation.messages.send": "Schicken",
  "negotiation.openDiscussions": "Offene Diskussionen",
  "negotiation.role": "Diskussionsrolle",
  "negotiation.role.buyer": "Käufer",
  "negotiation.role.buyer.verb": "Kauf",
  "negotiation.role.seller": "Verkäufer",
  "negotiation.role.seller.verb": "Verkauf",
  "negotiation.role.you": "Sie",
  "negotiation.status": "Diskussionsstatus",
  "negotiation.status.canceled": "Abgesagt",
  "negotiation.status.completed": "Vollendet",
  "negotiation.status.interest": "Interesse",
  "negotiation.status.ongoing": "Geht weiter",
  negotiations: "Diskussionen",
  newExternalLink: "Externen Link hinzufügen",
  newMake: "Neues Fabrikat",
  newModel: "Neues Modell",
  newPaymentMethod: "Methode hinzufügen",
  "newsletterSignupForm.error":
    "Wir konnten Sie nicht für den Newsletter anmelden. Bitte versuchen Sie es später noch einmal.",
  "newsletterSignupForm.inputPlaceholder": "Ihre E-Mail-Adresse",
  "newsletterSignupForm.submitButton.done": "Sie befinden sich in!",
  "newsletterSignupForm.text":
    "Bei Driven implementieren wir ständig neue Dinge. Wir halten Sie über unsere neuesten Projekte und Veranstaltungen auf dem Laufenden",
  "newsletterSignupForm.title": "Holen Sie sich die neuesten Driven-Updates",
  "newsletterSignupForm.title.done":
    "<0>Super! </0><1>Wir halten Sie auf dem Laufenden!</1>",
  newType: "Neue Kategorie",
  newVersionAvailable: "Neue Version verfügbar!",
  no: "Nein",
  noCollectors: "Keine Sammler",
  noDecimalPlaceAllowed: "Keine Dezimalstelle erlaubt",
  note: "Notiz",
  "notFound.description":
    "Wir können die von Ihnen gesuchte Seite offenbar nicht finden, da sie derzeit nicht verfügbar ist",
  "notFound.title": "404 – Räder weg",
  "notification.button.tooltip_one":
    "Sie haben {{count}} ungelesene Benachrichtigung",
  "notification.button.tooltip_other":
    "Sie haben {{count}} ungelesene Benachrichtigungen",
  "notification.button.tooltip_zero":
    "Sie haben keine ungelesenen Benachrichtigungen",
  "notification.collector.identityRejected.title":
    "Die Identitätsüberprüfung ist fehlgeschlagen",
  "notification.collector.identityUpdated.title": "Neue Identitätsprüfung",
  "notification.collector.identityVerified.body":
    "Nachdem Ihre Identität erfolgreich verifiziert wurde, können wir nun den Besitz Ihrer Fahrzeuge verifizieren, sodass diese in den Transaktionen aufgeführt werden können",
  "notification.collector.identityVerified.title": "Identität überprüft",
  "notification.collector.removeFromOrganization.collector.body":
    "Sie wurden aus dem {{organization}} entfernt",
  "notification.collector.removeFromOrganization.concierge.body":
    "<strong>{{username}}</strong> ({{email}}) wurde aus Ihrer Organisation entfernt",
  "notification.collector.removeFromOrganization.concierge.title":
    "Kollektor entfernt",
  "notification.collector.signedUp.body": "{{email}} hat sich angemeldet",
  "notification.collector.signedUp.title": "Neuer Sammler",
  "notification.concierge.collectorsUpdated": "Beauftragte aktualisiert",
  "notification.concierge.created.body":
    "{{email}} wurde zu Ihrer Organisation hinzugefügt",
  "notification.concierge.created.title": "Neuer Concierge",
  "notification.crew.curator.membership.created.body":
    "{{member}} hat eine Einladung angenommen und ist jetzt ein Kurator in Ihrer Crew",
  "notification.crew.curator.membership.created.title":
    "Einladung der Crew angenommen",
  "notification.dataRoom.membership.accepted.title":
    "Datenraum-Gruppenmitgliedschaft akzeptiert",
  "notification.dataRoom.membership.revoked.title":
    "Datenraum-Gruppenmitgliedschaft widerrufen",
  "notification.dataRoom.membership.withdrawn.body":
    "{{member}} hat eine Mitgliedschaft zurückgezogen",
  "notification.dataRoom.membership.withdrawn.title":
    "Datenraum-Gruppenmitgliedschaft zurückgezogen",
  "notification.dataRoom.message.title": "Neue Nachricht",
  "notification.historyRecord.draft.content":
    "{{typeName}} Record Entwurf für {{vehicleTitle}} wurde basierend auf kürzlich hochgeladenen Dokumenten erstellt. Überprüfen und speichern Sie ihn.",
  "notification.historyRecord.draft.title":
    "Entwurf eines Logbucheintrags erstellt",
  "notification.markAllAsRead": "Alles als gelesen markieren",
  "notification.membership.deleted.body":
    "Ihre Mitgliedschaft als {{role}} aus der Crew von {{username}} wurde gelöscht",
  "notification.membership.deleted.title": "Mitgliedschaft gelöscht",
  "notification.membership.withdrawn.body":
    "{{username}} hat seine Mitgliedschaft als {{role}} aus Ihrer Crew zurückgezogen",
  "notification.membership.withdrawn.title": "Mitgliedschaft entzogen",
  "notification.negotiation.accessLevels.updated.body":
    "Der Verkäufer teilte weitere Informationen über das Fahrzeug mit",
  "notification.negotiation.accessLevels.updated.title":
    "Verhandlungsdatenraum aktualisiert",
  "notification.negotiation.canceled.body": "Die Verhandlung wurde abgebrochen",
  "notification.negotiation.canceled.title": "Verhandlung abgebrochen",
  "notification.negotiation.interestAccepted.body":
    "Akzeptiert der Käufer Ihren Ansatz, können Sie nun mit der Verhandlung beginnen",
  "notification.negotiation.interestAccepted.title": "Interesse angenommen",
  "notification.negotiation.interestShown.title": "Interesse für Ihr Fahrzeug",
  "notification.negotiation.message.buyer": "Käufer",
  "notification.negotiation.message.seller": "Verkäufer",
  "notification.negotiation.message.title": "Neue Nachricht von {{role}}",
  "notification.serviceRequest.assigned.title":
    "Sie haben eine Serviceanfrage erhalten",
  "notification.serviceRequest.canceled.title": "Anfrage abgebrochen",
  "notification.serviceRequest.completed.title": "Anfrage abgeschlossen",
  "notification.serviceRequest.message.title": "Neue Nachrichte",
  "notification.serviceRequest.ongoing.title": "Anfrage in Arbeit",
  "notification.subscription.renewal.body":
    "Ihr Abonnement wird am {{renewalDate}} verlängert. Überprüfen Sie vorher Ihre Abonnementeinstellungen",
  "notification.subscription.renewal.title": "Abo-Verlängerung",
  "notification.subscription.trialEnd.body":
    "Ihre kostenlose Testversion läuft am {{trialEnd}} ab. Überprüfen Sie Ihre Abonnementeinstellungen, bevor es passiert",
  "notification.subscription.trialEnd.title": "Kostenlose Testversion endet",
  "notification.subscription.trialStart.body":
    "Sie können alle Driven-Funktionen bis zum {{trialEnd}} testen. Danach benötigen Sie ein Abonnement, um Ihre Garage zu verwalten",
  "notification.subscription.trialStart.body.partner":
    "Sie können alle Driven-Funktionen bis zum {{trialEnd}} testen. Danach benötigen Sie ein Abonnement, um Fahrzeuge unabhängig von der Partnerorganisation verwalten zu können",
  "notification.subscription.trialStart.title": "Driven Testversion",
  "notification.vehicle.handedOver.body":
    "Die Übergabe des Fahrzeugs wurde bestätigt",
  "notification.vehicle.handedOver.title": "Fahrzeug übergeben",
  "notification.vehicle.organizationUpdated.added.title":
    "Fahrzeug zu {{organization}} hinzugefügt",
  "notification.vehicle.organizationUpdated.title":
    "Fahrzeugorganisation aktualisiert",
  "notification.vehicle.organizationUpdated.withdrawn.title":
    "Fahrzeug von {{organization}} zurückgezogen",
  "notification.vehicle.ownershipRejected.title": "Eigentum abgelehnt",
  "notification.vehicle.ownershipUpdated.title": "Neue Eigentumsverifizierung",
  "notification.vehicle.ownershipVerified.body":
    "Sie können das Fahrzeug öffentlich machen oder es anonym in den Transaktionen auflisten",
  "notification.vehicle.ownershipVerified.title": "Eigentum bestätigt",
  "notification.vehicle.tagsUpdated": "Fahrzeugstichworte aktualisiert",
  "notification.vehicle.transferTargetUpdated.title":
    "Fahrzeug zur Übergabe angemeldet",
  notifications: "Benachrichtigungen",
  notProvided: "Nicht bereitgestellt",
  notSet: "Nicht eingestellt",
  noVehicles: "Keine Fahrzeuge",
  number: "Anzahl",
  numberOfCrewMembers: "Anzahl der Crewmitglieder",
  numberOfReadonlyVehicles: "Anzahl der schreibgeschützten Fahrzeuge",
  numberOfVehicles: "Anzahl der Fahrzeuge",
  odometer: "Kilometerstand",
  odometerLog: "Kilometerzählerprotokoll",
  odometerReading: "Kilometerstand",
  "onboarding.details.next": "Gehen Sie zur Garage",
  "onboarding.details.subtitle":
    "Ihr Konto ist eingerichtet und Ihre Garage ist bereit, mit Ihren ersten Fahrzeugen gefüllt zu werden! Wie wäre es, wenn Sie Ihre Erfahrung damit beginnen, Ihr Profil anzupassen?",
  "onboarding.details.title": "Willkommen!",
  "onboarding.skipTutorial": "Lernprogramm überspringen",
  onlyOneDecimalPlaceAllowed: "Es ist nur eine Dezimalstelle zulässig",
  organization: "Organisation",
  "organization.acme": "ACME",
  "organization.ascari": "Ascari",
  "organization.bi": "B.I. COLLECTR",
  "organization.curated": "CURATED",
  "organization.driven": "Driven",
  "organization.ilr": "ILR",
  "organization.kessel": "Kessel",
  "organization.sandbox": "Sandkasten",
  "organization.vehicles.emptyState.concierge":
    "Es sind Ihnen noch keine Fahrzeuge zugewiesen.",
  "organization.vehicles.emptyState.superConcierge":
    "In Ihrer Organisation gibt es noch keine Fahrzeuge.",
  organizations: "Organisationen",
  overview: "Überblick",
  owner: "Eigentümer",
  paid: "Bezahlt",
  password: "Passwort",
  passwordNotEqual: "Die Passwörter müssen übereinstimmen",
  passwordRequirements:
    "Das Passwort muss zwischen 8 und 64 Zeichen lang sein und muss Ziffern, Groß- und Kleinbuchstaben sowie Sonderzeichen enthalten.",
  paywall: "Paywall",
  paywallDisableConfirm:
    "Möchten Sie die Paywall für den ausgewählten Benutzer wirklich deaktivieren?",
  paywallDisabled: "Paywall deaktiviert",
  paywallEnableConfirm:
    "Sind Sie sicher, dass Sie Paywall für den ausgewählten Benutzer aktivieren möchten?",
  pending: "Ausstehend",
  performance: "Leistung",
  performanceNotAvailable:
    "Um das Diagramm anzuzeigen, stellen Sie bitte Folgendes sicher: 1) Der ursprüngliche Kaufpreis ist eingegeben. 2) Mindestens ein Verlaufseintrag mit einer Bewertung, oder dem Verkaufspreis, ist vorhanden.",
  photo: "Foto",
  photos: "Fotos",
  photosAndVideos: "Fotos und Videos",
  pickVehicles: "Fahrzeuge auswählen",
  power: "Leistung",
  poweredBy: "Powered by",
  "prefillSpecs.description":
    "Den Antriebsstrang Ihres Fahrzeugs finden Sie in der Bedienungsanleitung",
  "prefillSpecs.generate": "Mit KI ausfüllen",
  "prefillSpecs.help":
    "Nach der Auswahl des Antriebsstrangs tragen wir automatisch die Fahrzeugspezifikationen für Ihr spezifisches Modell ein",
  "prefillSpecs.help.disabled":
    "Der Antriebsstrang dieses Fahrzeugmodells ist nicht in unserer Datenbank. Bitte fügen Sie die Parameter manuell hinzu",
  "prefillSpecs.help.success":
    "Erfolgt! Nachfolgend haben wir automatisch einige Spezifikationen Ihres ausgewählten Fahrzeugs für Sie ausgefüllt",
  "prefillSpecs.label": "Antriebsstrang",
  "prefillSpecs.placeholder":
    "Bitte wählen Sie den Antriebsstrang Ihres Fahrzeugs aus",
  price: "Preis",
  privacyPolicy: "Datenschutzrichtlinie",
  racetrack: "Rennstrecke",
  redacted: "[redigiert]",
  referrer: "Referrer",
  register: "Registrieren",
  registerHere: "Hier registrieren",
  rejected: "Abgelehnt",
  relations: "Verbindungen",
  releaseNotes: "Versionshinweise",
  reload: "Neu laden",
  reloadInvoices: "Rechnungen neu laden",
  "reminders.emptyState.description":
    "Hier können Sie Erinnerungen für Ihre Garage einrichten. Wenn ein Erinnerungstermin fällig ist, erhalten Sie eine Benachrichtigung und eine E-Mail",
  remove: "Entfernen",
  removeExternalLink: "Externen Link entfernen",
  removeFromCollection: "Aus der Sammlung entfernen",
  removeFromLocation: "Vom Standort entfernen",
  removeFromOrganization: "Aus der Organisation entfernen",
  rename: "Umbenennen",
  requestAssignedTo: "Zugewiesen an",
  resendEmail: "E-Mail zurücksenden",
  reset: "Zurücksetzen",
  resetPassword: "Passwort zurücksetzen",
  results: "Ergebnisse",
  revoke: "Widerrufen",
  role: "Rolle",
  "role.admin": "Admin",
  "role.collector": "Sammler",
  "role.concierge": "Concierge",
  "role.curator": "Kurator",
  "role.dealer": "Händler",
  "role.dealership": "Autohaus",
  "role.organization_manager": "Organisationsmanager",
  "sandbox.create.description":
    "Erstellen Sie einen Sandbox-Benutzer, um die Plattform in einer sicheren Umgebung zu testen",
  "sandbox.create.finished":
    "Ihr Sandkasten wurde eingerichtet, laden Sie ihn neu, um alle Fahrzeuge zu sehen",
  "sandbox.create.success":
    "Ihr Sandbox-Benutzer wurde erstellt, die Fahrzeuge werden gerade bereitgestellt und erscheinen in Kürze in Ihrer Garage",
  "sandbox.create.title": "Sandkasten erstellen",
  save: "Speichern",
  saveAs: "Speichern als",
  search: "Suchen",
  seeListing: "Siehe Datenraum in Transaktionen",
  select: "Wählen",
  selectAll: "Wählen Sie Alle",
  selectDiscussion: "Diskussion auswählen",
  selectDocuments: "Dokumente auswählen",
  selectId: "Wählen Sie ID aus",
  selection: "Auswahl",
  selectMemberByUsername:
    "Wählen Sie das Mitglied anhand des Benutzernamens aus",
  selectRequest: "Anfrage auswählen",
  "service.type": "Servicetyp",
  "serviceRequest.attachments.help":
    "Wenn sich die Serviceanfrage auf ein Fahrzeug bezieht, sind die Anhänge über den Vault des Fahrzeugs zugänglich.",
  "serviceRequest.backToRequests": "Zurück zu den Anfragen",
  "serviceRequest.closedRequests": "Geschlossene Anfragen",
  "serviceRequest.create": "Anfragen erstellen",
  "serviceRequest.form.selectVehicleFirst":
    "Wählen Sie zuerst ein Fahrzeug aus",
  "serviceRequest.menu.accept": "Anfrage annehmen",
  "serviceRequest.menu.cancel": "Anfrage abbrechen",
  "serviceRequest.menu.complete": "Als erledigt markeiren",
  "serviceRequest.menu.edit": "Anfrage bearbeiten",
  "serviceRequest.openRequests": "Offene Anfragen",
  "serviceRequest.status": "Status",
  "serviceRequest.status.canceled": "Abgesagt",
  "serviceRequest.status.completed": "Vollendet",
  "serviceRequest.status.ongoing": "In Arbeit",
  "serviceRequest.status.requested": "Angefordert",
  "serviceRequest.userNotPartOfOrganization": "Nicht Teil der Organisation",
  settings: "Einstellungen",
  "settings.help.content":
    "Wenn Sie Unterstützung benötigen oder spezielle Fragen zu unserem Service haben, wenden Sie sich bitte an [support@driven.world](mailto:support@driven.world)",
  showInterest: "Interesse zeigen",
  signUp: "Melden Sie sich an",
  signUpClaim: "Bereits Mitglied?",
  size: "Größe",
  sortBy: "Sortiere nach",
  "sorting.addedNewest": "Hinzugefügt: Neueste zuerst",
  "sorting.addedOldest": "Hinzugefügt: Älteste zuerst",
  "sorting.crewMembersCountHighest":
    "Anzahl der Besatzungsmitglieder: Höchste zuerst",
  "sorting.crewMembersCountLowest":
    "Anzahl der Besatzungsmitglieder: Niedrigste zuerst",
  "sorting.emailAZ": "E-Mail: A-Z",
  "sorting.listedNewest": "Gelistet: Neueste zuerst",
  "sorting.listedOldest": "Aufgeführt: Älteste zuerst",
  "sorting.makeAZ": "Marke: A-Z",
  "sorting.nameAZ": "Name: A-Z",
  "sorting.odometerHighest": "Kilometerzähler: Höchster zuerst",
  "sorting.odometerLowest": "Kilometerzähler: niedrigster Wert zuerst",
  "sorting.priceHighest": "Preis: höchster zuerst",
  "sorting.priceLowest": "Preis: niedrigster zuerst",
  "sorting.productionYearNewest": "Baujahr: Neueste zuerst",
  "sorting.productionYearOldest": "Baujahr: Ältestes zuerst",
  "sorting.readonlyVehicleCountHighest":
    "Anzahl der schreibgeschützten Fahrzeuge: Höchste zuerst",
  "sorting.readonlyVehicleCountLowest":
    "Anzahl der schreibgeschützten Fahrzeuge: Niedrigste zuerst",
  "sorting.registeredLatest": "Registriert: das Neueste zuerst",
  "sorting.registeredOldest": "Eingetragen: Älteste zuerst",
  "sorting.surnameAZ": "Nachname: A-Z",
  "sorting.titleAZ": "Titel: A-Z",
  "sorting.titleZA": "Titel: Z-A",
  "sorting.usernameAZ": "Benutzername: A-Z",
  "sorting.valuationHighest": "Marktwert: höchste zuerst",
  "sorting.valuationLowest": "Marktwert: niedrigste zuerst",
  "sorting.vehicleCountHighest": "Anzahl der Fahrzeuge: Höchste zuerst",
  "sorting.vehicleCountLowest": "Anzahl der Fahrzeuge: Niedrigste zuerst",
  sortNone: "Keiner",
  specs: "Spezifikationen",
  "specs.aerodynamicsDragCoefficient": "Aerodynamik (Luftwiderstandsbeiwert)",
  "specs.aerodynamicsFrontalArea": "Aerodynamik (Frontalbereich)",
  "specs.back": "Zurück",
  "specs.batteryCapacity": "Batteriekapazität",
  "specs.bodyStyle": "Aufbau",
  "specs.brakesFront": "Bremsen vorne",
  "specs.brakesRear": "Bremsen hinten",
  "specs.carburetors": "Anzahl der Vergaser",
  "specs.cargoVolume": "Ladevolumen",
  "specs.chargingTime": "Ladezeit",
  "specs.clutch": "Kupplungstyp",
  "specs.co2Emissions": "CO2-Emissionen",
  "specs.colorExterior": "Außenfarbe",
  "specs.colorInterior": "Innenfarbe",
  "specs.cooling": "Kühlung",
  "specs.displacement": "Verschiebung",
  "specs.doors": "Anzahl der Türen",
  "specs.driveTrain": "Antriebstyp",
  "specs.driveType": "Antriebstyp",
  "specs.empty.readonly": "Keine Angaben gemacht",
  "specs.engineType": "Motortyp",
  "specs.extras": "Extras",
  "specs.frontTrack": "Vordere Spur",
  "specs.fuelCapacity": "Kraftstoffkapazität",
  "specs.fuelConsumption": "Kraftstoffverbrauch",
  "specs.fuelInjectors": "Anzahl der Einspritzdüsen",
  "specs.fuelSystem": "Kraftstoffsystem",
  "specs.fuelType": "Treibstoffart",
  "specs.gearBox": "Getriebe",
  "specs.gearBoxConstruction": "Getriebekonstruktion",
  "specs.gearBoxExtra": "Getriebe extra",
  "specs.gears": "Anzahl der Gänge",
  "specs.grossWeightLimit": "Bruttogewichtsgrenze",
  "specs.groundClearance": "Bodenfreiheit",
  "specs.height": "Höhe",
  "specs.homologation": "Homologation",
  "specs.hundredTo0": "100-0 km/h",
  "specs.importedFrom": "Importiert von",
  "specs.importStatus": "Importstatus",
  "specs.length": "Länge",
  "specs.manufacturedFrom": "Hergestellt aus",
  "specs.manufacturedUntil": "Hergestellt bis",
  "specs.maxSpeed": "Höchstgeschwindigkeit",
  "specs.numberElectricEngines": "Anzahl der Elektromotoren",
  "specs.numberOfOwners": "Anzahl der Eigentümer",
  "specs.numberProduced": "Produzierte Einheiten",
  "specs.powerBHP": "Bremsleistung",
  "specs.powerHP": "Leistung",
  "specs.powerKW": "Leistung",
  "specs.powerPeak": "Leistungsspitze",
  "specs.producedInCountry": "Im Land hergestellt",
  "specs.purchasePrice": "Kaufpreis",
  "specs.putIntoCirculation": "In Umlauf bringen",
  "specs.range": "Reichweite",
  "specs.rearTrack": "Hintere Spur",
  "specs.seats": "Anzahl Sitzplätze",
  "specs.tiresFront": "Reifen vorne",
  "specs.tiresRear": "Reifen hinten",
  "specs.topVehicles": "Top-Fahrzeuge",
  "specs.torque": "Drehmoment",
  "specs.torquePeak": "Drehmomentspitze",
  "specs.turbo": "Turbo",
  "specs.turningCircle": "Wendekreis",
  "specs.turningCircleCurbToCurb": "Wendekreis (Bordstein zu Bordstein)",
  "specs.turningCircleWallToWall": "Wendekreis (Wand zu Wand)",
  "specs.unladenWeight": "Leergewicht",
  "specs.wheelbase": "Radstand",
  "specs.width": "Breite",
  "specs.zeroTo100": "0-100 km/h",
  "specs.zeroTo200": "0-200 km/h",
  "specs.zeroTo300": "0-300 km/h",
  startTypingAddress: "Beginnen Sie mit der Eingabe der Adresse…",
  startVerification: "Gerät überprüfen",
  status: "Status",
  style: "Stil",
  subscribe: "Abonnieren",
  "subscribe.billing.title": "Abrechnungsdaten",
  "subscribe.error.failed":
    "Das Abonnement konnte nicht abgeschlossen werden. Versuchen Sie es später erneut.",
  "subscribe.error.fetchTiers":
    "Aktuelle Pläne konnten nicht geladen werden. Versuchen Sie es später erneut.",
  "subscribe.promoCode.add": "Promo-Code hinzufügen",
  "subscribe.promoCode.apply": "Anwenden",
  "subscribe.selected": "Ausgewähltes Abonnementpaket",
  "subscribe.success": "Das Abonnement wurde erfolgreich abgeschlossen",
  "subscribe.summary.plan":
    "Sie zahlen jeden Monat <strong>{{total}}</strong> als Grundgebühr. Der Betrag wird erstmals am <strong>{{renewalDate}}</strong> abgebucht und verlängert sich automatisch, bis er storniert wird.",
  "subscribe.summary.planExtension":
    "Die Gebühr für die Garagenplätze und Mitarbeiterplätze wird am Ende jedes monatlichen Abrechnungszeitraums entsprechend Ihrer aktuellen Nutzung am Tag der Verlängerung erhoben. Die anstehende Gebührenprognose können Sie in Ihren Abonnementeinstellungen einsehen.",
  "subscribe.summary.title": "Zusammenfassung",
  subscribeNow: "Abonniere jetzt",
  subscription: "Driven Abonnement",
  "subscription.amountDue":
    "<strong>Ihre nächste Rechnung entsprechend der aktuellen Nutzung: </strong>{{currency}} {{amount}}",
  "subscription.automaticRenewal":
    "<strong>Automatische Verlängerung: </strong>{{date}}",
  "subscription.canceled": "Abonnement erfolgreich gekündigt",
  "subscription.creditCardSetup.error":
    "Beim Einrichten der Rechnungsinformationen ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
  "subscription.error.fetch":
    "Ihr Abonnement konnte nicht geladen werden. Versuchen Sie es später erneut.",
  "subscription.expired":
    "Ihr Abonnement ist seit <strong>{{date}}</strong> abgelaufen. Bitte <strong>verwalten Sie Ihr Abonnement</strong>, um Driven weiterhin nutzen zu können.",
  "subscription.expired.short": "Kein Abonnement aktiv",
  "subscription.infoUnsubscribing":
    "Mit dem Abonnement erhalten Sie uneingeschränkten Zugriff auf Driven Garage und unsere exklusiven, nur für Abonnenten zugänglichen Funktionen wie Zusammenarbeit und Datenräume.\n\nBehalten Sie immer die volle Kontrolle. Wir geben Ihre Daten niemals an Dritte weiter und alle Ihre Dokumente werden verschlüsselt. Nicht einmal wir können sie sehen.",
  "subscription.infoUnsubscribing2":
    "Denken Sie über eine Stornierung nach? Kontaktieren Sie uns und wir finden eine passende Lösung für Sie und Ihre Sammlung. [info@riven.world](mailto:info@riven.world)",
  "subscription.manage": "Abonnement verwalten",
  "subscription.paymentMethod": "<strong>Zahlungsmethode: </strong>{{card}}",
  "subscription.quota.additional": "Zusätzliche",
  "subscription.quota.collaborationSeats": "Sitze für die Zusammenarbeit",
  "subscription.quota.collaborationSeats.disabled":
    "Aktualisieren Sie Ihr Abonnement für den Crew-Modus",
  "subscription.quota.garageSlots": "Garage Steckplätze",
  "subscription.quota.garageSlots.disabled":
    "Aktualisieren Sie Ihr Abonnement für mehr Werkstattplätze",
  "subscription.quota.included": "Eingeschlossen",
  "subscription.quota.transactionsListings":
    "<strong>{{quotaUsage}}</strong> Transaktionsdatenräume übrig",
  "subscription.quota.transactionsListings.disabled":
    "Aktualisieren Sie Ihr Abonnement für Transaktionsdatenräume",
  "subscription.quota.usage": "Verwendung",
  "subscription.renewalCanceled":
    "Ihr Abonnement läuft am <strong>{{date}}</strong> ab. Bitte <strong>stellen Sie Ihr Abonnement wieder her</strong>, um Driven weiterhin nutzen zu können.",
  "subscription.renewalDetailsError":
    "Beim Abrufen Ihrer Verlängerungsinformationen ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
  "subscription.renewalIntervalChanged":
    "Sie haben eine Änderung der <strong>{{interval}}</strong>-Abrechnung beantragt. Dies wird nach dem Ende Ihres aktuellen Abrechnungszeitraums aktiv.",
  "subscription.renewalTierChanged":
    "Sie haben ein Downgrade auf <strong>{{tier}}</strong> beantragt. Dies wird nach dem Ende Ihres aktuellen Abrechnungszeitraums aktiv.",
  "subscription.subscribe":
    "Sie haben noch keines unserer Pakete ausgewählt. Abonnieren Sie jetzt und genießen Sie alle Vorteile.",
  "subscription.trialPeriod":
    "Ihr Testzeitraum endet in <strong>{{interval}}</strong>.",
  "subscription.trialPeriod.short":
    "Testphase endet in <strong>{{interval}}</strong>",
  "subscription.unsubscribed.chargesDetail":
    "Die Gebühr für die Garagenplätze und Mitarbeiterplätze wird am Ende jedes monatlichen Abrechnungszeitraums entsprechend Ihrer aktuellen Nutzung am Tag der Verlängerung erhoben.",
  "subscription.unsubscribed.info":
    "Abonnieren Sie und erhalten Sie unbegrenzten Zugriff auf Driven Garage und unsere exklusiven, nur für Abonnenten zugänglichen Funktionen wie Zusammenarbeit und Datenräume.\n\nBehalten Sie immer die volle Kontrolle. Wir geben Ihre Daten niemals an Dritte weiter und alle Ihre Dokumente werden verschlüsselt. Nicht einmal wir können sie sehen.",
  "subscription.unsubscribed.info2":
    "Driven ist vollständig anpassbar – Sie zahlen nur für die Anzahl der Garagenstellplätze und Mitarbeitersitze, die Sie nutzen.",
  summary: "Zusammenfassung",
  surname: "Nachname",
  surnameRequired: "Nachname ist erforderlich",
  "system.tag.car_history": "Fahrzeughistorie",
  "system.tag.identity": "Identität",
  "system.tag.import": "Importieren",
  "system.tag.insurance": "Versicherung",
  "system.tag.ownership": "Eigentum",
  "system.tag.registration": "Anmeldung",
  systemTag: "System-Stichwort",
  tag: "Stichwort",
  tags: "Stichworte",
  termsAndConditions: "Geschäftsbedingungen",
  "textDetection.error.invalidImageType": "Ungültiger Bildtyp",
  "textDetection.error.passwordProtectedDocument": "Passwortgeschützt",
  "textDetection.status.failed": "Parsing failed",
  "textDetection.status.finished": "Bearbeitungsdatei",
  "textDetection.status.parsing.failed": "Parsing failed",
  "textDetection.status.parsing.succeeded": "Verlaufsdatensatz erstellt",
  "textDetection.status.started": "Bearbeitungsdatei",
  "textDetection.status.succeeded": "KI-Magie anwenden",
  tier: "Stufe",
  "tier.additional": "Zusätzliche",
  "tier.additional.collaboratorSeat": "{{price}} für einen Mitarbeitersitz",
  "tier.additional.vehicleSlot": "{{price}} für Fahrzeugplatz",
  "tier.aspiring_collector": "Angehender Sammler",
  "tier.baseSubscription.claim": "$49.95 pro Monat",
  "tier.baseSubscription.title": "Basisabonnement",
  "tier.collaboratorSeats.claim": "$19.95 pro Sitzplatz",
  "tier.collaboratorSeats.title": "Mitarbeitersitze",
  "tier.collector": "Collector",
  "tier.enthusiast": "Enthusiast",
  "tier.features.collaboration_one":
    "Zusammenarbeit ({{count}} Sitzplatz inbegriffen)",
  "tier.features.collaboration_other":
    "Zusammenarbeit ({{count}} Sitze inklusive)",
  "tier.features.collaboration_zero": "Zusammenarbeit",
  "tier.features.encryption": "Verschlüsselung von Dateien",
  "tier.features.encryption.description":
    "Optionale Ende-zu-Ende-Verschlüsselung von Dateien",
  "tier.features.includedVehicles_one": "{{count}} Fahrzeug inklusive",
  "tier.features.includedVehicles_other": "{{count}} Fahrzeuge inklusive",
  "tier.features.vehicleLimit_one": "{{count}} Fahrzeugplatz",
  "tier.features.vehicleLimit_other": "Bis zu {{count}} Fahrzeugsteckplätze",
  "tier.features.vehicleLimit_zero": "Keine Begrenzung der Fahrzeugstellplätze",
  "tier.garageSlots.claim_one": "Der erste Slot ist frei",
  "tier.garageSlots.claim_other": "Die ersten {{count}} Slots sind frei",
  "tier.garageSlots.claim_zero": "Keine freien Slots",
  "tier.garageSlots.tier_1": "$15.95 pro Slot, für 1–30 Slots",
  "tier.garageSlots.tier_2": "$12.95 pro Slot, für 31–100 Slots",
  "tier.garageSlots.tier_3": "$9.95 pro Slot, für 100+ Slots",
  "tier.garageSlots.title": "Garagenstellplätze",
  "tier.metered_usage": "Gemessene Nutzung",
  "tier.pro": "Pro",
  "tier.pro_collector": "Profi-Sammler",
  tierExpirationDate: "Ablauf der Stufe",
  "tiers.billedAnnually": "jährlich abgerechnet",
  "tiers.billedMonthly": "monatlich abgerechnet",
  "tiers.cancel": "Abbrechen",
  "tiers.cancelConfirm":
    "Sind Sie sicher, dass Sie Ihr aktuelles Abonnement kündigen möchten?",
  "tiers.change": "Ändern",
  "tiers.downgrade": "Downgrade",
  "tiers.enterprise": "Unternehmen",
  "tiers.enterprise.cta": "Buchen Sie ein Treffen",
  "tiers.enterprise.subtitle":
    "Kontaktieren Sie uns, um unsere exklusiven maßgeschneiderten Pakete zu besprechen",
  "tiers.enterprise.title": "Suchen Sie eine maßgeschneiderte Lösung?",
  "tiers.month": "Monat",
  "tiers.note":
    "*Der Crew-Modus ermöglicht es zahlenden Abonnenten, anderen Benutzern entsprechend ihrem aktiven Plan Zugriff auf ihre Sammlung und Funktionen zu gewähren. Konten nur für Besatzungsmitglieder sind kostenlos, erlauben jedoch keine Asset-Erstellung und -Verwaltung, es sei denn, das Besatzungsmitglied ist auch ein zahlender Abonnent. Erfordert eine Registrierung.",
  "tiers.perMonth": "pro Monat",
  "tiers.restore": "Wiederherstellen",
  "tiers.startTrial": "Testversion starten",
  "tiers.subscribe.disabled":
    "Ihr Verbrauch liegt derzeit über den Quoten dieser Stufe",
  "tiers.title": "Abonnement-Stufen",
  "tiers.upgrade": "Aktualisierung",
  timeline: "Zeitleiste",
  title: "Titel",
  "title.about": "Um",
  "title.admin": "Administrator",
  "title.admin.concierges": "Concierges",
  "title.admin.layoutScopes": "Layoutbereiche",
  "title.admin.listings": "Datenräume",
  "title.admin.usageHistory": "Nutzungsgeschichte",
  "title.admin.users": "Benutzer",
  "title.admin.vehicles": "Fahrzeuge",
  "title.careers": "Karriere",
  "title.changePassword": "Kennwort ändern",
  "title.collection.notFound": "Sammlung nicht gefunden",
  "title.collector.notFound": "Collector nicht gefunden",
  "title.consent": "Einwilligung",
  "title.crewInvitationExpired": "Ihre Einladung ist abgelaufen",
  "title.curation.operationNotAllowed": "Betrieb nicht erlaubt",
  "title.dashboard": "Dashboard",
  "title.explore": "Erkunden",
  "title.explore.collections": "Entdecken Sie Sammlungen",
  "title.explore.vehicles": "Entdecken Sie Fahrzeuge",
  "title.garage": "Garage",
  "title.garage.activity": "Aktivität",
  "title.garage.addCollection": "Fügen Sie eine Sammlung hinzu",
  "title.garage.addHistoryRecord.add": "Neuer Geschichtsrekord",
  "title.garage.addLocation": "Füge einen Ort hinzu",
  "title.garage.addVehicle": "Fügen Sie ein Fahrzeug hinzu",
  "title.garage.collections": "Sammlungen",
  "title.garage.dashboard": "Dashboard",
  "title.garage.dataRoom": "Datenraum",
  "title.garage.dataRoom.activity": "Aktivität",
  "title.garage.dataRoom.manage": "Verwalten Sie",
  "title.garage.dataRoom.messages": "Nachrichten",
  "title.garage.dataRooms": "Datenräume",
  "title.garage.gallery": "Galerie",
  "title.garage.locations": "Standorte",
  "title.garage.logBook": "Logbuch",
  "title.garage.logBook.odometer": "Kilometerzähler",
  "title.garage.logBook.valuation": "Preisverlauf",
  "title.garage.messages": "Nachrichten",
  "title.garage.reminders": "Erinnerungen",
  "title.garage.requests": "Anfragen",
  "title.garage.timeline": "Zeitleiste",
  "title.garage.vault": "Vault",
  "title.garage.vehicles": "Fahrzeuge",
  "title.garage.wishlist": "Wunchliste",
  "title.job": "Arbeit",
  "title.job.notFound": "Job nicht gefunden",
  "title.listing.notFound": "Datenraum nicht gefunden",
  "title.login": "Anmeldung",
  "title.maintenance": "Wartung",
  "title.mfa": "Multi-Faktor-Authentifizierung",
  "title.notFound": "404 – Räder weg",
  "title.onboarding.actions": "Onboarding: Erste Aktionen",
  "title.onboarding.details": "Onboarding: Details",
  "title.onboarding.introduction": "Onboarding: Einführung",
  "title.organization.collectors": "Sammler",
  "title.organization.dealers": "Händler",
  "title.organization.dealerships": "Autohäuser",
  "title.organization.locations": "Standorte",
  "title.organization.requests": "Anfragen",
  "title.organization.requests.details": "Einzelheiten",
  "title.organization.requests.messageBoard": "Messageboard",
  "title.organization.services": "Dienstleistungen",
  "title.organization.settings": "Einstellungen",
  "title.organization.usageHistory": "Nutzungsgeschichte",
  "title.organization.user_management": "Benutzerverwaltung",
  "title.organization.vehicles": "Fahrzeuge",
  "title.releaseNotes": "Versionshinweise",
  "title.required": "Titel erforderlich",
  "title.resetPassword": "Passwort zurücksetzen",
  "title.sandbox": "Sandkasten",
  "title.serviceRequest": "Serviceanfrage",
  "title.serviceRequest.attachments": "Anhänge",
  "title.serviceRequest.messages": "Nachrichten",
  "title.settings": "Einstellungen",
  "title.settings.accountManagement": "Kontoverwaltung",
  "title.settings.accountManagement.subtitle":
    "Als Driven-Benutzer haben Sie stets die volle Kontrolle über Ihr Konto. Sie können jederzeit die folgenden Aktionen ausführen.",
  "title.settings.collaboration": "Zusammenarbeit",
  "title.settings.crew": "Besatzung",
  "title.settings.curate": "Kuratieren",
  "title.settings.encryption": "Verschlüsselung",
  "title.settings.experiments": "Experimente",
  "title.settings.organizations": "Organisationen",
  "title.settings.private": "Private Daten",
  "title.settings.profile": "Profil",
  "title.settings.security": "Sicherheit",
  "title.settings.subscription": "Abonnement",
  "title.settings.subscription.invoices": "Rechnungen",
  "title.settings.subscription.membership": "Mitgliedschaft",
  "title.settings.subscription.paymentMethods": "Zahlungsarten",
  "title.settings.tagManager": "Tag-Manager",
  "title.settings.tagManager.subtitle":
    "Hier können Sie die Tags überprüfen und selbst neue erstellen. Mithilfe von Tags können Sie dann beliebige Dokumente kategorisieren",
  "title.settings.verification": "Überprüfung",
  "title.signup": "Melden Sie sich an",
  "title.transactions": "Transaktionen",
  "title.transactions.dataRoom": "Datenraum",
  "title.transactions.dataRooms": "Datenräume",
  "title.transactions.dataRoomSettings": "Einstellungen",
  "title.transactions.messageBoard": "Messageboard",
  "title.transactions.negotiations": "Diskussionen",
  "title.unsubscribe": "Abbestellen",
  "title.usageHistory": "Nutzungshistorie",
  "title.vehicle.notFound": "Fahrzeug nicht gefunden",
  to: "Zu",
  toggleTheme: "Dunkler Modus",
  tokenInvalid: "Der von Ihnen verwendete Token ist abgelaufen",
  toYear: "Bis Jahr",
  transactions: "Transaktionen",
  "transactions.dataRoom.externalLinks": "Ausgewählte externe Links",
  "transactions.dataRoom.externalLinks.empty":
    "Keine externen Links ausgewählt",
  "transactions.dataRoom.gallery": "Ausgewählte Galeriemedien",
  "transactions.dataRoom.gallery.empty": "Keine Galeriemedien ausgewählt",
  "transactions.dataRoom.grant.button": "Änderungen speichern",
  "transactions.dataRoom.grant.subtitle":
    "Sie können einem potenziellen Käufer detaillierten Zugriff auf Ihre Fahrzeugdaten gewähren. Dadurch können sie bestimmte Bereiche Ihres Datenraums sehen.",
  "transactions.dataRoom.grant.title": "Gewähren Sie nur Lesezugriff",
  "transactions.dataRoom.negotiation.canceled":
    "Die Verhandlung wurde abgebrochen",
  "transactions.dataRoom.negotiation.empty": "Es wurde noch nichts geteilt",
  "transactions.dataRoom.negotiation.interest":
    "Warten auf die Annahme des Interesses durch den Verkäufer",
  "transactions.dataRoom.specs": "Spezifikationen",
  "transactions.dataRoom.specs.empty": "Keine Spezifikationen",
  "transactions.dataRoom.vault": "Ausgewählte Dateien",
  "transactions.dataRoom.vault.empty": "Keine Dateien ausgewählt",
  "transactions.dataRooms.cta": "Datenraum erstellen",
  "transactions.dataRooms.empty":
    "Sie haben noch keine Datenräume veröffentlicht. Erstellen Sie einen Datenraum für ein Auto, das Sie zuerst anbieten möchten.",
  "transactions.fromPrice": "Ab Preis",
  "transactions.listings": "Datenräume",
  "transactions.toPrice": "Zum Preis",
  "transactions.transactions": "Transaktionen",
  transferred: "Übertragen",
  transferVehicle: "Transferfahrzeug",
  transmission: "Übertragung",
  type: "Kategorie",
  unarchiveVehicle: "Fahrzeug aus dem Archiv entfernen",
  undo: "Undo",
  unhighlight: "Hervorhebung aufheben",
  unknownDevice: "Unbekanntes Gerätemodell",
  unsubscribe: "Abbestellen",
  "unsubscribe.confirmation":
    "Sie sind dabei, sich von der Zusendung von Marketing-E-Mails an <strong>{{email}}</strong> abzumelden. Möchten Sie fortfahren?",
  "unsubscribe.success": "Erfolgreich abbestellt",
  "unsubscribed.hero.freeVehiclesMaxed":
    "SIE HABEN DIE MAXIMAL ZULÄSSIGE KOSTENLOSE FAHRZEUGE ERREICHT\n\n**Fügen Sie den Rest Ihrer Sammlung hinzu**",
  "unsubscribed.hero.title":
    "IHRE AUTOSAMMLUNG, ALLES AN EINEM ORT\n\n**ANGETRIEBENE GARAGE**",
  "unsubscribed.title":
    "Testen Sie eines unserer Pakete 6 Monate lang kostenlos",
  "unsubscribed.usps.badge-check.content":
    "Alle Besitzer der Fahrzeuge, die Sie in Driven öffentlich finden, wurden von unserem Team verifiziert, das ist eine echte Community.",
  "unsubscribed.usps.badge-check.title": "Bestätigen Sie Ihre Inhaberschaft",
  "unsubscribed.usps.database.content":
    "Wir wissen, wie schwierig es ist, all diese Reparaturrechnungen und Dokumente in einem Ordner aufzubewahren. In Driven können Sie sie alle **in Ihrem digitalen Vault zentralisieren**. Umfangreiche Dokumentation ist nicht nur schön – sie ist die Grundlage, die es Ihnen ermöglicht, den Wert Ihrer Sammlung langfristig zu erhalten und zu steigern. Befreien Sie sich von Ihren Excel-Tabellen und verwandeln Sie Ihre Fahrzeuge ganz einfach in vollständig dokumentierte virtuelle Meisterwerke. Stellen Sie alle Informationen zusammen, die Ihre Fahrzeuge einzigartig machen.",
  "unsubscribed.usps.database.title": "Datenmanagement in Perfektion",
  "unsubscribed.usps.flag-checkered.content":
    "Bleiben Sie mit unserem digitalen Kilometerzähler über den aktuellen Kilometerstand Ihres Fahrzeugs auf dem Laufenden. Sie können ihn ganz einfach bei jeder tollen Fahrt oder jedem Rennen aktualisieren und das Ereignis protokollieren",
  "unsubscribed.usps.flag-checkered.title": "Planen Sie Ihre Reisen",
  "unsubscribed.usps.vault.content":
    "Wir wissen, wie schwierig es ist, all diese Reparaturrechnungen und Dokumente in einem Ordner aufzubewahren. In Driven können Sie sie alle **in Ihrem digitalen Vault zentralisieren**.",
  "unsubscribed.usps.vault.title": "Organisieren Sie Ihre Dokumente",
  update: "Aktualisieren",
  updateOdometer: "Kilometerzähler aktualisieren",
  updateVehicleConsignment: "Fahrzeugsendung aktualisieren",
  updateVehicleLocation: "Fahrzeugstandort aktualisieren",
  upgrade: "Aktualisierung",
  upgradeYourSubscriptionToShowInterest:
    "Aktualisieren Sie Ihr Abonnement, um Interesse zeigen zu können",
  uploadDocuments: "Dokumente hochladen",
  uploadEncrypted: "Verschlüsseln und hochladen",
  uploadError: "Beim Hochladen der Dateien ist ein Fehler aufgetreten",
  uploadImage: "Bild hochladen",
  uploadImages: "Bilder hochladen",
  uploadPhotos: "Fotos hochladen",
  uploadVehicle: "Laden Sie ein Fahrzeug hoch",
  useAsDefault: "Als Standard verwenden",
  user: "Benutzer",
  "user.crew.active": "Aktiv",
  "user.crew.alert.verification":
    "Um Besatzungsmitglieder einzuladen, müssen Sie Ihre Identität überprüfen",
  "user.crew.availableSeats": "Aktive Besatzungsmitglieder ({{seatsInUse}})",
  "user.crew.content":
    "Ihre Crew hat vollen Zugang zu Ihrer Garage. In Ihrem Auftrag können sie beispielsweise Ihr Vermögen verwalten und Ihre Dokumente organisieren. Sie können Ihre persönlichen Daten nicht einsehen. Ihre Aktionen können aufgezeichnet und überprüft werden.",
  "user.crew.empty": "Sie haben noch kein Besatzungsmitglied",
  "user.crew.inactive": "Inaktiv",
  "user.crew.inactive.security": "2FA ist nicht aktiviert.",
  "user.crew.inactive.verification":
    "Die Verifizierung ist nicht abgeschlossen.",
  "user.crew.invite": "Einladung zur Crew",
  "user.crew.invite.confirmed": "Einladung von {{username}} angenommen",
  "user.crew.invite.createNew": "Neue Einladung erstellen",
  "user.crew.invite.description":
    "Senden Sie diesen Link an jeden, den Sie als Teil Ihrer Crew in Ihren Collaboration-Service einbeziehen möchten.",
  "user.crew.invite.expired": "Abgelaufen",
  "user.crew.invite.expires": "Läuft ab",
  "user.crew.invite.invalidated": "Einladung ungültig",
  "user.crew.invite.new": "Neue Einladung",
  "user.crew.invite.sendViaEmail": "Per E-Mail versenden",
  "user.crew.invite.view": "Einladung ansehen",
  "user.curation.alert.security":
    "Zum Kuratieren müssen Sie die Zwei-Faktor-Authentifizierung aktivieren",
  "user.curation.alert.subtitle":
    "Während Ihrer Tätigkeit als Kurator werden Ihre Handlungen aufgezeichnet und können überprüft werden",
  "user.curation.alert.title": "Die Kuratierungsaktivität wird protokolliert",
  "user.curation.alert.verification":
    "Zum Kuratieren müssen Sie Ihre Identität überprüfen",
  "user.curation.content":
    "Als Crewmitglied haben Sie vollen Zugriff auf eine weitere Sammlergarage. Sie können in ihrem Namen beispielsweise Vermögenswerte verwalten, Dokumente und Medien organisieren. Sie haben keinen Zugriff auf deren personenbezogene Daten. Während des Kuratierens werden Ihre Aktionen aufgezeichnet und können überprüft werden.",
  "user.curation.operationNotAllowed":
    "Als Kurator können Sie Fahrzeuge und Sammlungen verwalten, jedoch keine persönlichen Daten",
  "user.curation.start": "Beginn der Kuratierung",
  "user.curation.withdraw": "Rückzug aus der Besatzung",
  "user.encryption.ai.info":
    "Dieses Mass an Datenschutz bringt einen Kompromiss mit sich: Unser System, einschliesslich KI-Tools, kann auf verschlüsselte Dateien nicht zugreifen oder sie analysieren. Daher stehen bestimmte Funktionen, wie die automatische Erstellung von Verlaufsdatensätze, für diese Dateien nicht zur Verfügung.",
  "user.encryption.description":
    "Bei Driven stehen die Privatsphäre und Sicherheit unserer Sammler an oberster Stelle. Wir setzen fortschrittliche Verschlüsselungsmethoden ein, um sicherzustellen, dass Ihre Daten vertraulich und sicher bleiben. Wir erstellen ein einzigartiges Paar kryptografischer Schlüssel für Sie: einen öffentlichen Schlüssel und einen privaten Schlüssel unter Verwendung von RSA-OAEP sowie einen symmetrischen Schlüssel für die Datenverschlüsselung mit AES-GCM.<br /><br />Der symmetrische Schlüssel, bekannt als Data Encryption Key (DEK), wird verwendet, um Ihre Daten effizient zu verschlüsseln und zu entschlüsseln. Um den DEK zu schützen, verschlüsseln wir ihn mit Ihrem öffentlichen Schlüssel. Das bedeutet, dass nur Ihr entsprechender privater Schlüssel den DEK entschlüsseln kann, wodurch sichergestellt wird, dass Ihre Daten sicher bleiben, selbst wenn der verschlüsselte DEK abgefangen wird.<br /><br />Ihr privater Schlüssel wird zusätzlich gesichert, indem er mit einem Schlüssel verschlüsselt wird, der aus Ihrer persönlichen Passphrase mittels AES-GCM abgeleitet wird. Dieser abgeleitete Schlüssel stellt sicher, dass selbst wenn jemand Zugriff auf Ihren verschlüsselten privaten Schlüssel erhält, er ihn ohne Kenntnis Ihrer Passphrase nicht entschlüsseln kann. Wichtig ist, dass wir Ihre Passphrase oder Ihren unverschlüsselten privaten Schlüssel niemals in unserem System speichern.<br /><br />In unserem Speicher halten wir nur die verschlüsselten Versionen Ihres privaten Schlüssels und des DEK, zusammen mit Ihrem öffentlichen Schlüssel. Dieser Ansatz bedeutet, dass es ohne Ihre Passphrase praktisch unmöglich ist, auf Ihre entschlüsselten Schlüssel oder Daten zuzugreifen.<br /><br />Wenn Sie auf Ihre verschlüsselten Daten zugreifen möchten, geben Sie Ihre Passphrase ein. Mit dieser Passphrase leiten wir den benötigten Schlüssel ab, um Ihren privaten Schlüssel zu entschlüsseln. Sobald Ihr privater Schlüssel entschlüsselt ist, verwenden wir ihn, um den DEK zu entschlüsseln. Schließlich entschlüsselt der DEK Ihre Daten, sodass Sie sicher darauf zugreifen können.<br /><br />Dieser gestaffelte Verschlüsselungsprozess stellt sicher, dass Ihre Daten in jedem Schritt geschützt sind. Selbst wenn jemand unbefugten Zugriff auf unseren Speicher erlangen würde, könnte er Ihre Daten ohne Ihre eindeutige Passphrase nicht entschlüsseln. Wir sind verpflichtet, Ihr Vertrauen zu bewahren, indem wir Ihre Privatsphäre und Sicherheit in allen Aspekten unseres Services priorisieren.",
  "user.encryption.keys.info":
    "Ihre Schlüssel sind eingerichtet. Sie können verschlüsselte Dateien in den Tresor hochladen",
  "user.encryption.passphrase.change": "Passphrase ändern",
  "user.encryption.passphrase.init": "Passphrase initialisieren",
  "user.encryption.title": "Verschlüsselung auf dem Gerät",
  "user.experiments.feature.aiValuation.body":
    "Das neuronale Netz wird zur Schätzung des Marktwerts Ihrer Fahrzeuge verwendet. Dieser basiert auf den technischen Daten des Fahrzeugs, dem Antriebsstrang, dem Kilometerstand und der aktuellen Marktsituation.",
  "user.experiments.feature.aiValuation.caption":
    "Die Schätzung dient nur zu Informationszwecken und kann fehlerhaft sein. Sie sollte nicht als Referenz für Investitionsentscheidungen verwendet werden..",
  "user.experiments.feature.aiValuation.title": "Schätzung der Bewertung",
  "user.experiments.feature.backlogHistoryRecordParser.body":
    "Alle Dateien in Vault werden von einem neuronalen Netzwerk verarbeitet, um einen Verlaufsdatensatz zu identifizieren. Dies ist ein langwieriger Vorgang und kann einige Zeit dauern. Sie werden benachrichtigt, wenn Entwurfsverlaufsdatensätze erstellt werden.",
  "user.experiments.feature.backlogHistoryRecordParser.caption":
    "Diese Funktion erfordert, dass die Daten ausserhalb der Schweiz verarbeitet werden. Durch die Aktivierung dieser Funktion stimmen Sie den aktualisierten Geschäftsbedingungen zu.",
  "user.experiments.feature.backlogHistoryRecordParser.title":
    "Analysieren Sie den Verlaufsdatensatz aus vorhandenen Vaultdateien",
  "user.experiments.feature.historyRecordParser.body":
    "Ein neuronales Netzwerk wird verwendet, um einen Verlaufsdatensatz aus neuen, in den Vault hochgeladenen Dateien zu identifizieren.",
  "user.experiments.feature.historyRecordParser.caption":
    "Diese Funktion erfordert, dass die Daten ausserhalb der Schweiz verarbeitet werden. Durch die Aktivierung dieser Funktion stimmen Sie den aktualisierten Geschäftsbedingungen zu.",
  "user.experiments.feature.historyRecordParser.title":
    "Verlaufsdatensatz aus Vault analysieren",
  "user.experiments.feature.historyRecordParser.vaultAlert.enabled.collector":
    "Experimentelle Funktion aktiviert. Alle neu hochgeladenen Dateien werden geparst, um Verlaufsdatensätze automatisch zu identifizieren.",
  "user.experiments.feature.historyRecordParser.vaultAlert.enabled.concierge":
    "Collector hat eine experimentelle Funktion aktiviert. Alle neu hochgeladenen Dateien werden geparst, um Verlaufsdatensätze automatisch zu identifizieren.",
  "user.experiments.feature.historyRecordParser.vaultAlert.undefined.collector":
    "Aktivieren Sie die experimentelle Funktion <experimentsLink>{{feature}}</experimentsLink>, um automatisch Verlaufsdatensätze aus neu hochgeladenen Dateien zu identifizieren.",
  "user.experiments.feature.invitation.description":
    "Hier können Sie experimentelle Funktionen aktivieren oder deaktivieren. Die Funktionen befinden sich noch in der Entwicklung und funktionieren möglicherweise nicht wie erwartet.",
  "user.experiments.feature.invitation.title": "Experimentelle Merkmale",
  "user.password.reset.email":
    "Wir haben Ihnen einen Link zum Zurücksetzen Ihres Passworts gesendet",
  "user.password.reset.expired":
    "Das Token ist abgelaufen, bitte fordern Sie ein neues an",
  "user.security.mfa.description":
    "Sie haben für Ihr Konto die Zwei-Faktor-Authentifizierung aktiviert. Sie können unten den Faktor auswählen, den Sie verwenden möchten. Sie können diese Faktoren später jederzeit deaktivieren.",
  "user.security.mfa.email.body":
    "Richten Sie Ihre E-Mail-Adresse ein, um die Codes zu erhalten",
  "user.security.mfa.email.title": "E-Mail-Adresse",
  "user.security.mfa.invitation.cta": "Stellen Sie zusätzliche Sicherheit ein",
  "user.security.mfa.invitation.description":
    "Bei uns sind die <strong>Privatsphäre</strong> und <strong>Sicherheit</strong> unserer Sammler am wichtigsten. Aus diesem Grund <strong>wir empfehlen Ihnen, jetzt die Zwei-Faktor-Authentifizierung zu aktivieren</strong> für ein noch höheres Maß an Sicherheit für Ihr Konto. Das ist wirklich einfach.",
  "user.security.mfa.invitation.title":
    "Richten Sie ganz einfach zusätzliche Sicherheit mit der 2-Faktor-Authentifizierung ein",
  "user.security.mfa.otp.body":
    "Richten Sie Ihre Authentifizierungs-App ein. Wir empfehlen<br /><1>Google Authenticator</1> oder <3>Authy</3>",
  "user.security.mfa.otp.title": "Authentifizierungs-App",
  "user.security.mfa.webauthn.body":
    "Richten Sie Ihr physisches Gerät als Authentifizierungsgerät ein",
  "user.security.mfa.webauthn.title": "Physisches Gerät",
  username: "Nutzername",
  usernameInvalid:
    "Der Benutzername darf nur Buchstaben, Zahlen, Unterstriche und Bindestriche enthalten.",
  users: "Benutzer",
  userTag: "Benutzer-Tag",
  utmCampaign: "UTM Campaign",
  utmMedium: "UTM Medium",
  utmSource: "UTM Source",
  "validation.required": "Erforderlich",
  validFrom: "Gültig ab",
  validUntil: "Gültig bis",
  valuation: "Marktwert",
  valuationDate: "Marktwertsdatum",
  value: "Wert",
  valueForOdometerInconsistent:
    "Diese Lesart steht im Widerspruch zur Geschichte dieses Fahrzeugs",
  valueNotNumber: "Der Wert muss eine Zahl sein",
  valueOutsideRange: "Wert außerhalb des Bereichs (0 - 2147483647)",
  variant: "Variante",
  variantPlaceholder:
    "Ausstattungsvariante (z. B. LX), Paket (z. B. Sport) usw.",
  vaultEmpty:
    "Der Vault <1>speichert und verwaltet alle Dokumente</1> Ihrer Fahrzeuge. Sie können bereits das erste Dokument hochladen.",
  vaultInvitation:
    "Der Vault <1>speichert und verwaltet alle Dokumente</1> Ihres Fahrzeugs. Sie können bereits das erste Dokument hochladen.",
  vehicle: "Fahrzeug",
  "vehicle.count_one": "{{count}} Fahrzeug",
  "vehicle.count_other": "{{count}} Fahrzeuge",
  "vehicle.count.filtered":
    "Es werden {{filtered}} von {{total}} Fahrzeugen angezeigt",
  "vehicle.make.other": "Andere",
  "vehicle.make.unknown": "Unbekannt",
  "vehicle.managedByPartner":
    "Dieses Fahrzeug wird verwaltet von <strong>{{title}}</strong>",
  "vehicle.organization.assign": "Der Organisation zuweisen",
  "vehicle.organization.withdraw": "Aus der Organisation austreten",
  "vehicle.serviceRequest.menu": "Service anfordern",
  "vehicle.serviceRequest.request": "Anfrage",
  "vehicle.serviceRequest.title": "Fordern Sie einen neuen Service an",
  "vehicle.status": "Status",
  "vehicle.status.archived": "Archiviert",
  "vehicle.status.for_sale": "Zu verkaufen",
  "vehicle.status.for_trade_in": "Zur Inzahlungnahme",
  "vehicle.status.listed": "Gelistet",
  "vehicle.status.private": "Im Besitz",
  "vehicle.status.sold": "Verkauft",
  "vehicle.status.transferred": "Übertragen",
  "vehicle.status.transferring": "Übertragen",
  "vehicle.status.under_right_condition_for_sale":
    "Im richtigen Zustand zu verkaufen",
  "vehicle.status.wishlist": "Wunschliste",
  "vehicle.step.manageCollections.selected": "Du hast ausgewählt",
  "vehicle.step.manageCollections.title": "Wählen Sie Sammlungen aus",
  "vehicle.technicalData": "Technische Daten",
  "vehicle.technicalData.chassisNumber": "Fahrgestellnummer",
  "vehicle.technicalData.colorCode": "Farbcode",
  "vehicle.technicalData.engineNumber": "Motornummer",
  "vehicle.technicalData.gearboxNumber": "Getriebenummer",
  "vehicle.technicalData.serialNumber": "Seriennummer",
  "vehicle.technicalData.vin": "Vin",
  "vehicle.transfer.claim.button": "Fahrzeug beanspruchen",
  "vehicle.transfer.claim.description":
    "Beanspruchen Sie dieses Fahrzeug? Wenn Sie fortfahren, hat der Besitzer die Möglichkeit, Ihre Kontodaten zu bestätigen, dann wird das Fahrzeug an Ihre Werkstatt übertragen.",
  "vehicle.transfer.claim.description.concierge":
    "Beanspruchen Sie dieses Fahrzeug für den Sammler? Wenn Sie fortfahren, hat der Eigentümer die Möglichkeit, seine Kontodaten zu bestätigen, dann wird das Fahrzeug in seine Werkstatt überführt",
  "vehicle.transfer.confirm.description":
    "Möchten Sie die Übertragung an {{username}} bestätigen?",
  "vehicle.transfer.waiting.owner.description":
    "Der Eigentümer wurde benachrichtigt, dass das Fahrzeug abgeholt wurde. Nachdem er die Angaben des vorgesehenen Empfängers bestätigt hat, wird das Fahrzeug an dessen Werkstatt übergeben.",
  "vehicle.transfer.waiting.target.description":
    "Wir warten darauf, dass der neue potenzielle Besitzer das Fahrzeug abholt. In diesem Fall werden Sie benachrichtigt und können ihre persönlichen Daten bestätigen, bevor die Übertragung abgeschlossen wird.",
  "vehicle.value": "Marktwert",
  "vehicle.value.insurance": "Versicherungswert",
  "vehicle.value.purchase": "Kaufpreis",
  "vehicle.value.sale": "Verkaufspreis",
  "vehicle.value.taxable": "Steuerpflichtiger Wert",
  "vehicle.vehicleData": "Fahrzeugdaten",
  "vehicle.vehicleData.condition": "Zustand",
  "vehicle.vehicleData.currentlyRegistered": "Derzeit registriert",
  "vehicle.vehicleData.currentlyRegisteredCountry":
    "Derzeit registriertes Land",
  "vehicle.vehicleData.currentlyRegisteredDate": "Derzeit registriertes Datum",
  "vehicle.vehicleData.firstRegistration": "Erstanmeldung",
  "vehicle.vehicleData.firstRegistrationCountry": "Erstzulassungsland",
  "vehicle.vehicleData.firstRegistrationDate": "Erster Anmeldetermin",
  "vehicle.vehicleData.homologation": "Homologation",
  "vehicle.vehicleData.homologationDate": "Homologationsdatum",
  "vehicle.vehicleData.importStatus": "Importstatus",
  "vehicle.vehicleData.importStatusDate": "Datum des Importstatus",
  "vehicle.vehicleData.insuranceTitle": "Versicherungstitel",
  "vehicle.vehicleData.insured": "Versichert",
  "vehicle.vehicleData.insuredDate": "Versichertes Datum",
  "vehicle.vehicleData.lastInspection": "Letzte Fahrzeuginspektion",
  "vehicle.vehicleData.lastInspectionDate": "Datum der letzten Inspektion",
  "vehicle.vehicleData.numberPlate": "Nummernschild",
  "vehicle.vehicleData.tyres": "Reifen",
  "vehicle.vehicleData.tyres.description": "Herstellungsjahr/DOT",
  "vehicle.vehicleData.veteranDate": "Veteranendatum",
  vehicleCreated: "Fahrzeug erstellt",
  vehicleNotFound: "Fahrzeug nicht gefunden",
  vehicles: "Fahrzeuge",
  version: "Version: {{version}}",
  videos: "Videos",
  viewLess: "Weniger anzeigen",
  viewLocation: "Standort anzeigen",
  viewLog: "Protokoll ansehen",
  viewLogbook: "Logbuch ansehen",
  viewMore: "Mehr sehen",
  vin: "VIN",
  visibility: "Sichtweite",
  walkThrough: "Gehen Sie durch",
  walkThroughUrl: "Gehen Sie durch die URL",
  warehouse: "Lager",
  website: "Webseite",
  welcome: "Willkommen",
  welcomeBack: "Willkommen zurück",
  wishlist: "Wunchliste",
  "wishlist.cta": "Zur Wunschliste hinzufügen",
  "wishlist.empty": "Ihre Wunschliste ist leer",
  "wishlist.yearFrom": "Vor {{year}}",
  "wishlist.yearTo": "Nach {{year}}",
  withdraw: "Zurückziehen",
  withdrawInterest: "Zinsen abziehen",
  year: "Baujahr",
  yearFrom: "Ab Jahr",
  yearTo: "Bis Jahr",
  yes: "Ja",
  yesDisable: "ja, deaktivieren",
};

export default translations;
